import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Buffer } from "buffer";
import { ValidatorForm } from "react-material-ui-form-validator";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import FormatColorTextIcon from "@mui/icons-material/FormatColorText";
import {
  Autocomplete,
  Container,
  Box,
  Typography,
  Select,
  MenuItem,
  IconButton,
} from "@mui/material";
import AddIcon from "@material-ui/icons/Add";
import SaveIcon from "@material-ui/icons/Save";
import ReactSpeedometer from "react-d3-speedometer";
import Confetti from "react-confetti";
import MaterialTable from "material-table";
import UiUtils from "../../../provider/UiUtils";
import Button from "@material-ui/core/Button";
// import BackupIcon from "@mui/icons-material/Backup";
import ClearIcon from "@mui/icons-material/Clear";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import TextField from "@material-ui/core/TextField";
import store from "../../../redux/store";
import FetchServerData from "../../../provider/FetchServerData";
import Utils from "../../../provider/Utils";
import PtsAlert from "../ptsAlert/PtsAlert";
import "./Pledge.css";
import MenuWithBreadScrum from "../menu/MenuWithBreadScrum";
import EditButton from "../buttons/EditButton";
import DeleteButton from "../buttons/DeleteButton";
import {
  ExportDonations_Url,
  GetMessage_Url,
  ImportDonations_Url,
  PledgeDonationAdd_Url,
  PledgeDonationDelete_Url,
  PledgeDonationGet_Url,
  PledgeDonationUpdate_Url,
  PledgeStaticData_Url,
  PledgeUpdated_Url,
} from "../../../provider/ServiceUrl";
import DonationImportFile from "../../../assets/importTemplate/GivBeeDonations.csv";
import SaveButton from "../buttons/SaveButton";
import { BUSINESS_DOMAIN, MESSAGE_TYPES } from "../../../provider/Enums";
import DeleteIcon from "@material-ui/icons/Delete";
import HorizontalBar from "./HorizontalBar";
// import BorderColorIcon from "@mui/icons-material/BorderColor";
// import FormatColorTextIcon from "@mui/icons-material/FormatColorText";
// import BannerColorPicker from "./BannerColorPicker";
class Pledge extends Component {
  header = store.getState().header.header;
  businessDomain =
    store.getState().appUserData.appUserData.appuser?.businessDomain;
  businessDomainId = store.getState().businessDomain?.businessDomainId;
  breadCrumb = [
    { pageid: "/messages", uiname: " Message List" },
    { pageid: "", uiname: "Pledge meter setup" },
  ];
  donationBreadCrumb = [
    { pageid: "/messages", uiname: " Message List" },
    { pageid: "", uiname: "Donation Meter Setup" },
  ];
  constructor(props) {
    super(props);
    // let str = window.location.origin;
    let action = props.action;
    let messageId = props.messageId;
    if (!action && props.state) {
      action = props.state.action;
      messageId = props.state.messageId;
    }
    if (action && Utils.equalsIgnoreCase(action, "view")) {
      this.getPledgeStaticData();
      this.getPledgeDetails(messageId);
    }

    this.state = {
      messageId: messageId,
      initialPage: 0,
      pageSize: 20,
      fundraisingGoal: 0,
      messageName: "",
      selectedFile: { name: "" },
      selectedDonationFile: { name: "" },
      selectedBanner: { name: "" },
      bannerImage: null,
      backgroundImage: null,
      pledgeId: "",
      donationAmount: "",
      addDonationAmount: "",
      addFirstName: "",
      addLastName: "",
      firstName: "",
      lastName: "",
      iframeCode: "",
      bannerText: "",
      donationUrl: "",
      textDonation: 0,
      offlineDonation: 0,
      totalDonation: 0,
      messageType: null,
      displayType: null,
      displayColor: null,
      displayEffect: null,
      donationList: [],
      displayTypeList: [],
      colorTypeList: [],
      effectTypeList: [],
      displayStyles: [],
      measureTypes: [],
      displayStyle: null,
      measureType: null,
      isAnonymous: false,
      isShowAnonymous: false,
      isOptinkeyword: false,
      isAutoscroll: true,
      isShowGoalAmount: false,
      tickerOverlayOpen: false,
      isFundraisingGoal: false,
      alertVisible: false,
      donationOpen: false,
      addDonationAmountFocus: false,
      is3dEffect: false,
      isConfetti: false,
      render: false,
      isDragging: false,
      isBackgroundImageDragging: false,
      anchorEl: null,
      pickerFor: null,
      backgroundImageUrl: null,
      newUrl: null,
      activeColorType: "",
      bannerBackground: "#ffffff",
      bannerTextColor: "#353538",
      meterFontColor: "#353538",
      backgroundImageError: "",
      sampleDonationList: [
        {
          firstName: "Mary",
          lastName: "Smith",
          amount: 200,
        },
        {
          firstName: "James",
          lastName: "Johnson",
          amount: 250,
        },
        {
          firstName: "Linda",
          lastName: "Williams",
          amount: 100,
        },
        {
          firstName: "David",
          lastName: "Brown",
          amount: 250,
        },
        {
          firstName: "Robert",
          lastName: "Jones ",
          amount: 150,
        },
      ]
    };
  }

  getPledgeStaticData() {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService(PledgeStaticData_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let pledgeDetails = output.data;
          let displayStyle = Utils.getArrayElement(
            pledgeDetails.displayStyles,
            0
          );
          this.setState({
            displayTypeList: pledgeDetails.displayTypes,
            colorTypeList: pledgeDetails.colorTypes,
            effectTypeList: pledgeDetails.effectTypes,
            displayStyles: pledgeDetails.displayStyles,
            measureTypes: pledgeDetails.measureTypes,
            displayStyle: displayStyle,
          });
        } else {
        }
      }
    );
  }

  getPledgeDetails(messageId) {
    const postObject = {
      header: this.header,
      smsMessage: {
        id: messageId,
      },
    };

    FetchServerData.callPostService(GetMessage_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          const messageDetails = output.data.smsMessage || {};
          const pledgeDetails = messageDetails.pledgeDetails || {};

          // ✅ Extract permissions safely
          const subDomainPerms =
            output.data.subDomainObjectPrivileges?.DonationReport || [];
          const getSubDomainPermission =
            Utils.getRolePermission(subDomainPerms);
          const getReportPermission = getSubDomainPermission?.[2] ?? false;

          // Pagination check
          const isPaging =
            (pledgeDetails.donationList?.length || 0) > this.state.pageSize;

          // Handle banner image
          const hasBanner = !!pledgeDetails?.bannerImage?.url;
          const bannerImageUrl = hasBanner
            ? `${pledgeDetails?.bannerImage?.url?.trim()}?v=${Date.now()}`
            : null;
          // Handle background image
          const hasBackground = !!pledgeDetails?.backgroundImage?.url;
          const backgroundImageUrl = hasBackground
            ? `${pledgeDetails.backgroundImage?.url?.trim()}?v=${Date.now()}`
            : null;

          // Update state in one go for performance
          this.setState({
            pledgeId: pledgeDetails.id,
            offlineDonation: pledgeDetails.offlineDonation,
            textDonation: pledgeDetails.textDonation,
            totalDonation: pledgeDetails.totalDonation,
            isOptinkeyword: pledgeDetails.isOptinkeyword,
            isAutoscroll: pledgeDetails.isAutoscroll,
            isShowGoalAmount: pledgeDetails.isShowGoalAmount,
            is3dEffect: pledgeDetails.is3dEffect,
            isConfetti: pledgeDetails.isConfetti,
            donationList: pledgeDetails.donationList,
            displayType: pledgeDetails.displayType,
            displayColor: pledgeDetails.displayColor,
            displayEffect: pledgeDetails.displayEffect,
            displayStyle: pledgeDetails.displayStyle,
            measureType: pledgeDetails.measureType,
            fundraisingGoal: pledgeDetails?.goalAmount || 0,
            messageType: messageDetails.messageType,
            messageName: messageDetails.messageName,
            iframeCode: pledgeDetails.iframeCode,
            bannerText: pledgeDetails.bannerText,
            meterFontColor: pledgeDetails.meterFontColor || "#353538",
            bannerTextColor: pledgeDetails.bannerTextColor || "#353538",
            bannerBackground: pledgeDetails.bannerBackground || "#ffffff",
            isPaging: isPaging,
            getReportPermission,

            // Image states
            newUrl: bannerImageUrl,
            showFileView: hasBanner,
            backgroundImageUrl: backgroundImageUrl,
            showBackgroundImageView: hasBackground,
            bannerImage: pledgeDetails.bannerImage,
            backgroundImage: pledgeDetails.backgroundImage,
            donationUrl: pledgeDetails.donationUrl,
            // Reset
            selectedFile: { name: "" },
            selectedBackgroundImage: { name: "" },
            render: true,
          });
        } else {
          PtsAlert.error("Failed to load pledge details.");
        }
      })
      .catch((error) => {
        PtsAlert.error("Error loading pledge details.");
      });
  }

  cancelDonationExcelFile() {
    this.setState({
      selectedDonationFile: { name: "" }
    })
  }
  handleDonationFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState({ selectedDonationFile: file });
      this.onFileChange(file);
    }
  };

  handleDonationFileDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      this.setState({ selectedDonationFile: file, isDragging: false });
      this.onFileChange(file);
    }
  };

  handleDonationFileDragOver = (e) => {
    e.preventDefault();
    this.setState({ isDragging: true });
  };

  handleDonationFileDragLeave = (e) => {
    e.preventDefault();
    this.setState({ isDragging: false });
  };

  onFileChange = (file) => {
    if (file) {
      const fileName = file?.name?.toLowerCase();
      if (!fileName.endsWith(".csv")) {
        PtsAlert.error("Please upload a valid CSV file.");
        return;
      }
      // this.setState({ selectedDonationFile: file }, () => {
      //   this.excelImportDonation();
      // });
    }
  };

  excelImportDonation = (e) => {
    if (
      !this.state.selectedDonationFile?.name ||
      this.state.selectedDonationFile?.name === ""
    ) {
      PtsAlert.error("Please select file to upload");
      return;
    }
    let header = store.getState().header.header;
    const formData = new FormData();

    // Update the formData object
    formData.append(
      "file",
      this.state.selectedDonationFile,
      this.state.selectedDonationFile.name
    );
    formData.append("sessionid", header.sessionid);
    formData.append("tid", header.tid);
    formData.append("userid", header.userid);
    formData.append("appclient", header.appclient);
    formData.append("isAp", header.isAp);
    formData.append("pledgeDetailsId", this.state.pledgeId);
    FetchServerData.callPostFileUpload(ImportDonations_Url, formData).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          // this.fileUploadRef.current.value = "";
          this.setState({
            selectedDonationFile: { name: "" },
          });
          this.getPledgeDetails(this.state.messageId);
        }
      }
    );
  };
  handleShowAnonymous() {
    this.setState({ isShowAnonymous: !this.state.isShowAnonymous });
  }
  handleAddShowAnonymous() {
    this.setState({ isAnonymous: !this.state.isAnonymous });
  }
  handle3dEffectThermometer() {
    this.setState({ is3dEffect: !this.state.is3dEffect });
  }
  handleConfettiThermometer() {
    this.setState({ isConfetti: !this.state.isConfetti });
  }
  handleMeterGoal() {
    this.setState({ isShowGoalAmount: !this.state.isShowGoalAmount });
  }
  handleOptinKeyword() {
    this.setState({ isOptinkeyword: !this.state.isOptinkeyword });
  }
  handleAutoScroll() {
    this.setState({ isAutoscroll: !this.state.isAutoscroll });
  }
  // handleMeterStyleChange(displayStyle) {
  //   if (displayStyle.name === "Ticker") {
  //     this.setState({
  //       displayStyle: displayStyle,
  //       bannerImage: null,
  //       backgroundImage: null,
  //       bannerTextColor: "#ffffff",
  //       bannerBackground: "#353538",
  //       donationUrl: "",
  //     });
  //   } else {
  //     this.setState({
  //       displayStyle: displayStyle,
  //       bannerTextColor: this.state.bannerTextColor,
  //       bannerBackground: this.state.bannerBackground,
  //     });
  //   }
  // }
  handleMeterStyleChange(displayStyle) {
    const isTicker = displayStyle?.name === "Ticker";

    this.setState((prevState) => {
      if (isTicker) {
        // Store current non-Ticker values before resetting
        return {
          displayStyle,
          prevBannerImage: prevState.bannerImage,
          prevBackgroundImage: prevState.backgroundImage,
          prevBannerTextColor: prevState.bannerTextColor,
          prevBannerBackground: prevState.bannerBackground,
          prevDonationUrl: prevState.donationUrl,

          // Reset for Ticker mode
          bannerImage: null,
          backgroundImage: null,
          bannerTextColor: "#ffffff",
          bannerBackground: "#353538",
          donationUrl: "",
          isConfetti: false,
        };
      } else {
        // Restore previous non-Ticker values if they exist
        return {
          displayStyle,
          bannerImage: prevState.prevBannerImage || prevState.bannerImage,
          backgroundImage:
            prevState.prevBackgroundImage || prevState.backgroundImage,
          bannerTextColor:
            prevState.prevBannerTextColor || prevState.bannerTextColor,
          bannerBackground:
            prevState.prevBannerBackground || prevState.bannerBackground,
          donationUrl: prevState.prevDonationUrl || prevState.donationUrl,
        };
      }
    });
  }
  handleDisplayTypeChange(displayType) {
    this.setState({ displayType: displayType });
  }

  handleColorChange(e) {
    const selectedId = e.target.value;
    const selectedOption = this.state.colorTypeList.find(
      (item) => item.id === selectedId
    );
    if (selectedOption) {
      this.setState({
        displayColor: selectedOption,
      });
    }
  }
  handleEffectChange(effect) {
    this.setState({ displayEffect: effect });
  }
  handleMeasureTypeChange(measureType) {
    this.setState({ measureType: measureType });
  }

  handleFundraisingGoalChange(e) {
    this.setState({ fundraisingGoal: e.target.value });
  }
  handleFirstNameChange(e) {
    this.setState({ firstName: e.target.value });
  }
  handleLastNameChange(e) {
    this.setState({ lastName: e.target.value });
  }
  handleDonationAmountChange(e) {
    this.setState({ donationAmount: e.target.value });
  }
  handleAddDonationAmountChange(e) {
    this.setState({ addDonationAmount: e.target.value });
  }
  handleAddFirstNameChange(e) {
    this.setState({ addFirstName: e.target.value });
  }
  handleAddLastNameChange(e) {
    this.setState({ addLastName: e.target.value });
  }

  addDonationToBackend() {
    const postObject = {
      header: this.header,
      donationDetails: {
        amount: this.state.addDonationAmount,
        firstName: this.state.addFirstName,
        lastName: this.state.addLastName,
        isShowAnonymous: this.state.isAnonymous,
      },
      pledgeDetails: {
        id: this.state.pledgeId,
      },
    };
    FetchServerData.callPostService(PledgeDonationAdd_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let donationDetails = output.data.pledgeDetails;
          let isPaging = false;
          if (donationDetails.donationList?.length > this.state.pageSize) {
            isPaging = true;
          }
          PtsAlert.success(output.message);
          this.donationAmountRef.current.focus();
          this.setState({
            donationList: donationDetails.donationList,
            offlineDonation: donationDetails.offlineDonation,
            textDonation: donationDetails.textDonation,
            totalDonation: donationDetails.totalDonation,
            addDonationAmount: "",
            addFirstName: "",
            addLastName: "",
            isPaging: isPaging,
            addDonationAmountFocus: true,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  updateDonationToBackend() {
    const postObject = {
      header: this.header,
      donationDetails: {
        id: this.state.donationId,
        amount: this.state.donationAmount,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        isShowAnonymous: this.state.isShowAnonymous,
        pledgeDetails: {
          id: this.state.pledgeId,
        },
      },
    };
    FetchServerData.callPostService(PledgeDonationUpdate_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let donationDetails = output.data.pledgeDetails;
          let isPaging = false;
          if (donationDetails.donationList?.length > this.state.pageSize) {
            isPaging = true;
          }
          this.setState({
            donationList: donationDetails.donationList,
            offlineDonation: donationDetails.offlineDonation,
            textDonation: donationDetails.textDonation,
            totalDonation: donationDetails.totalDonation,
            isPaging: isPaging,
            open: false,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  UpdatePledgeDataToBackend() {
    const postObject = {
      header: this.header,
      pledgeDetails: {
        id: this.state.pledgeId,
        goalAmount: this.state.fundraisingGoal,
        bannerText: this.state.bannerText,
        displayType: this.state.displayType,
        displayColor: this.state.displayColor,
        displayEffect: this.state.displayEffect,
        displayStyle: this.state.displayStyle,
        measureType: this.state.measureType,
        isShowGoalAmount: this.state.isShowGoalAmount,
        isOptinkeyword: this.state.isOptinkeyword,
        isAutoscroll: this.state.isAutoscroll,
        is3dEffect: this.state.is3dEffect,
        isConfetti: this.state.isConfetti,
        bannerTextColor: this.state.bannerTextColor,
        bannerBackground: this.state.bannerBackground,
        bannerImage: this.state.bannerImage,
        backgroundImage: this.state.backgroundImage,
        meterFontColor: this.state.meterFontColor,
        donationUrl: this.state.donationUrl,
      },
    };
    FetchServerData.callPostService(PledgeUpdated_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          // PtsAlert.success(output.message);
          let pledgeDetails = output.data.pledgeDetails;
          let messageDetails = output.data.pledgeDetails?.message;
          let isPaging = false;
          if (pledgeDetails.donationList?.length > this.state.pageSize) {
            isPaging = true;
          }
          this.setState({
            pledgeId: pledgeDetails.id,
            offlineDonation: pledgeDetails.offlineDonation,
            textDonation: pledgeDetails.textDonation,
            totalDonation: pledgeDetails.totalDonation,
            isShowGoalAmount: pledgeDetails.isShowGoalAmount,
            isOptinkeyword: pledgeDetails.isOptinkeyword,
            isAutoscroll: pledgeDetails.isAutoscroll,
            donationList: pledgeDetails.donationList,
            displayType: pledgeDetails.displayType,
            displayColor: pledgeDetails.displayColor,
            displayEffect: pledgeDetails.displayEffect,
            fundraisingGoal: messageDetails?.goalAmount,
            messageName: messageDetails.messageName,
            isPaging: isPaging,
            render: true,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  viewCancel() {
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      this.props.navigate("/eventMessages", {
        state: {
          action: "view",
          eventId: this.businessDomainId,
        },
      });
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/dptextMessages", {
        state: {
          action: "view",
          eventId: this.businessDomainId,
        },
      });
    } else {
      this.props.navigate("/messages");
    }
  }

  deleteDonationToBackend() {
    const postObject = {
      header: this.header,
      donationDetails: {
        id: this.state.donationId,
      },
    };

    FetchServerData.callPostService(PledgeDonationDelete_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let donationDetails = output.data.pledgeDetails;
          // for (let i = 0; i < this.state.donationList.length; i++) {
          //   if (this.state.donationList[i].id === donationDetails.id) {
          //     this.state.donationList.splice(i, 1);
          //   }
          // }
          this.setState({
            donationList: donationDetails.donationList,
            offlineDonation: donationDetails.offlineDonation,
            textDonation: donationDetails.textDonation,
            totalDonation: donationDetails.totalDonation,
            donationOpen: false,
            render: true,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  showActionButton(rowData) {
    return (
      <>
        <div
          className="col-md-12 d-flex justify-content-center"
          style={{ textAlign: "center" }}
        >
          {rowData.ismanual ? (
            <span className="ms-2" style={{ cursor: "pointer" }}>
              <EditButton onClick={() => this.editDonationDetails(rowData)} />
            </span>
          ) : (
            <span
              className="ms-2"
              style={{ width: "40px", padding: "3px" }}
            ></span>
          )}
          <span className="ms-2 align-item-end" style={{ cursor: "pointer" }}>
            <DeleteButton
              domainObject={`${rowData.firstName} ${rowData.lastName}`}
              onClick={() => this.deleteDonationToBackend(rowData)}
            />
          </span>
        </div>
      </>
    );
  }

  // aninymousChecked() {
  //   return (
  //     <>
  //       <input
  //         type="checkbox"
  //         value={this.state.isShowAnonymous}
  //         onChange={(e) => this.handleShowAnonymous(e)}
  //         checked={this.state.isShowAnonymous}
  //       />
  //     </>
  //   );
  // }

  getDonationDetails(data) {
    const postObject = {
      header: this.header,
      donationDetails: {
        id: data.id,
        pledgeDetails: {
          id: this.state.pledgeId,
        },
      },
    };
    FetchServerData.callPostService(PledgeDonationGet_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let donationDetails = output.data.donationDetails;
          this.setState({
            donationAmount: donationDetails.amount,
            firstName: donationDetails.firstName,
            lastName: donationDetails.lastName,
            isShowAnonymous: donationDetails.isShowAnonymous,
            donationId: donationDetails.id,
            open: true,
          });
        } else {
        }
      })
      .catch((error) => { });
  }
  editDonationDetails(data) {
    this.getDonationDetails(data);
  }

  handleClose() {
    this.setState({ open: false });
  }

  handleMaterialTablePageChange(page, pageSize) {
    this.setState({ initialPage: page, pageSize: pageSize });
  }

  excelDownloadDonationList() {
    const postObject = {
      header: this.header,
      pledgeDetails: {
        id: this.state.pledgeId,
      },
    };

    FetchServerData.callPostService(ExportDonations_Url, postObject).then(
      (output) => {
        let AllContactExcelData = output.data;
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          const byteArray = new Buffer(
            AllContactExcelData.data.replace(/^.+base64,/, ""),
            "base64"
          );
          const outputFilename = AllContactExcelData.filename;
          const url = URL.createObjectURL(new Blob([byteArray]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", outputFilename);
          document.body.appendChild(link);
          link.click();
        } else {
        }
      }
    );
  }

  handleTickerOverlayDilogboxOpen() {
    this.setState({
      tickerOverlayOpen: true,
    });
  }
  handleTickerOverlayClose() {
    this.setState({
      tickerOverlayOpen: false,
    });
  }
  editFundraisingGoal() {
    this.setState({
      isFundraisingGoal: !this.state.isFundraisingGoal,
    });
  }

  onCopy = (e) => {
    if (navigator?.clipboard) {
      navigator?.clipboard?.writeText(this.state.iframeCode);
    }
    this.setState({ alertVisible: true });
    setTimeout(() => {
      this.setState({ alertVisible: false, copiedIndex: null });
    }, 1000);
  };

  handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState({ selectedFile: file });
      this.onLogoChange(file);
    }
  };

  handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      this.setState({ selectedFile: file, isDragging: false });
      this.onLogoChange(file);
    }
  };

  handleDragOver = (e) => {
    e.preventDefault();
    this.setState({ isDragging: true });
  };

  handleDragLeave = (e) => {
    e.preventDefault();
    this.setState({ isDragging: false });
  };

  // onLogoChange = (file) => {
  //   // const file = event.target.files[0];
  //   if (!file) return;

  //   const allowedTypes = ["image/png", "image/jpeg", "image/gif"];
  //   const maxSize = 5 * 1024 * 1024; // 5 MB

  //   if (!allowedTypes.includes(file.type)) {
  //     this.setState({
  //       imageError: "The file type is not supported (must be png, jpg, gif).",
  //     });
  //     return;
  //   }
  //   if (file.size > maxSize) {
  //     this.setState({
  //       imageError: "The file size is too large (5 MB maximum).",
  //     });
  //     return;
  //   }

  //   const objectUrl = URL.createObjectURL(file);
  //   const img = new Image();

  //   img.onload = () => {
  //     URL.revokeObjectURL(objectUrl);
  //     const { width: w, height: h } = img;

  //     if (w <= 400 && h <= 100) {
  //       this.setState(
  //         {
  //           imagePreview: objectUrl,
  //           imageError: "",
  //           selectedBanner: file,
  //           currentFile: objectUrl,
  //         },
  //         () => this.uploadPledgeBanner()
  //       );
  //     } else {
  //       this.setState({
  //         imagePreview: null,
  //         selectedBanner: file,
  //         currentFile: objectUrl,
  //         imageError:
  //           "The image dimensions are too big (400 × 100 pix maximum).",
  //       });
  //     }
  //   };

  //   img.onerror = () => {
  //     URL.revokeObjectURL(objectUrl);
  //     this.setState({ imageError: "Invalid image file." });
  //   };

  //   img.src = objectUrl;
  // };

  onLogoChange = (file) => {
    if (!file) return;

    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/gif"];
    const maxSize = 5 * 1024 * 1024; // 5 MB max
    const fileType = file?.type?.split("/")[0];

    if (!allowedTypes.includes(file.type)) {
      this.setState({
        imageError: "Unsupported file type. Only PNG, JPG, or GIF allowed.",
      });
      return;
    }

    if (file.size > maxSize) {
      this.setState({ imageError: "File size too large (5 MB max)." });
      return;
    }

    const objectUrl = URL.createObjectURL(file);
    const img = new Image();

    img.onload = () => {
      const { width, height } = img;

      if (width <= 400 && height <= 100) {
        // Convert to Base64
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64Data = reader.result.split(",")[1]; // remove data:image/png;base64,
          this.setState({
            imageError: "",
            selectedBanner: file,
            currentFile: objectUrl,
            newUrl: objectUrl,
            fileType: fileType,
            showFileView: true,
            bannerImage: {
              id: null,
              contentType: "image",
              fileData: base64Data,
              filename: file?.name,
            },
          });
        };
        reader.readAsDataURL(file);
      } else {
        this.setState({
          imagePreview: null,
          showFileView: false,
          fileType: null,
          newUrl: null,
          selectedBanner: null,
          currentFile: null,
          imageError: "Image dimensions must not exceed 400 × 100 pixels.",
          bannerLogo: null,
        });
        URL.revokeObjectURL(objectUrl);
      }
    };

    img.onerror = () => {
      this.setState({
        imageError: "Invalid or corrupted image file.",
        imagePreview: null,
        selectedBanner: null,
        newUrl: null,
        currentFile: null,
        showFileView: false,
      });
      URL.revokeObjectURL(objectUrl);
    };

    img.src = objectUrl;
  };

  handleBackgroundImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState({ selectedBackgroundImage: file });
      this.onBackgroundImageChange(file);
    }
  };

  handleBackgroundImageDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      this.setState({
        selectedBackgroundImage: file,
        isBackgroundImageDragging: false,
      });
      this.onBackgroundImageChange(file);
    }
  };

  handleBackgroundImageDragOver = (e) => {
    e.preventDefault();
    this.setState({ isBackgroundImageDragging: true });
  };

  handleBackgroundImageDragLeave = (e) => {
    e.preventDefault();
    this.setState({ isBackgroundImageDragging: false });
  };

  onBackgroundImageChange = (file) => {
    if (!file) return;

    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/gif"];
    const maxSize = 5 * 1024 * 1024; // 5 MB max
    const fileType = file?.type?.split("/")[0];

    if (!allowedTypes.includes(file.type)) {
      this.setState({
        backgroundImageError:
          "Unsupported file type. Only PNG, JPG, or GIF allowed.",
      });
      return;
    }

    if (file.size > maxSize) {
      this.setState({
        backgroundImageError: "File size too large (5 MB max).",
      });
      return;
    }

    const objectUrl = URL.createObjectURL(file);
    const img = new Image();

    img.onload = () => {
      const { width, height } = img;

      if (width >= 800 && height >= 550) {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64Data = reader.result.split(",")[1];
          this.setState({
            backgroundImageError: "",
            selectedBackgroundImage: file,
            backgroundImageUrl: objectUrl,
            backgroundImageType: fileType,
            showBackgroundImageView: true,
            backgroundImage: {
              id:
                this.state.backgroundImage !== null
                  ? this.state.backgroundImage?.id
                  : null,
              contentType: "image",
              fileData: base64Data,
              filename: file?.name,
            },
          });
        };
        reader.readAsDataURL(file);
      } else {
        this.setState({
          backgroundImagePreview: null,
          showBackgroundImageView: false,
          backgroundImageType: null,
          backgroundImageUrl: null,
          selectedBackgroundImage: { name: "" },
          backgroundImageError:
            "Background image must be at least 800 x 550 pix.",
          backgroundImage: null,
        });
        URL.revokeObjectURL(objectUrl);
      }
    };

    img.onerror = () => {
      this.setState({
        imageError: "Invalid or corrupted image file.",
        imagePreview: null,
        selectedBanner: null,
        currentFile: null,
        showFileView: false,
      });
      URL.revokeObjectURL(objectUrl);
    };

    img.src = objectUrl;
  };
  uploadPledgeBanner = (e) => {
    if (
      !this.state.selectedBanner.name ||
      this.state.selectedBanner.name === ""
    ) {
      PtsAlert.error("Please select file to upload");
      return;
    }
    let header = store.getState().header.header;
    const formData = new FormData();
    formData.append(
      "file",
      this.state.selectedBanner,
      this.state.selectedBanner.name
    );
    formData.append("tid", header.tid);
    formData.append("sessionid", header.sessionid);
    formData.append("userid", header.userid);
    formData.append("isAp", header.isAp);
    formData.append("appclient", header.appclient);
    formData.append("pledgeid", this.state.pledgeId);
    // Details of the uploaded file

    FetchServerData.callPostService(
      "/pledgems/uploadBannerImage",
      formData
    ).then((output) => {
      if (output.status === "SUCCESS") {
        this.logoUploadRef.current.value = "";
        let pledgeBannerData = output.data.pledgeDetails;
        if (pledgeBannerData?.bannerImage !== null) {
          // showFile = true;
          let byteArray = "";
          let pledgeBannerUrl =
            "data:application/*;base64," + pledgeBannerData?.bannerImage;
          if (pledgeBannerData?.bannerImage !== null) {
            byteArray = new Buffer(
              pledgeBannerData?.bannerImage.replace(/^.+base64,/, ""),
              "base64"
            );
            const url = URL.createObjectURL(new Blob([byteArray]));
            let fileName = pledgeBannerUrl;

            let urlArr = fileName.split(".");
            let fileType = urlArr[1];
            this.setState({
              newUrl: url,
              fileType: fileType,
              showFileView: true,
            });
          }
        }

        // this.setState({
        //   render: true,
        //   action: "view",
        //   currentFile: null,
        //   selectedFile: logoData,
        // });
      }
    });
  };

  deletePledgeBannerInBackend() {
    // const postObject = {
    //   header: this.header,
    //   pledgeDetails: {
    //     id: this.state.pledgeId,
    //   },
    // };
    // FetchServerData.callPostService(
    //   "/pledgems/deleteBannerImage ",
    //   postObject
    // ).then((output) => {
    //   if (output.status === "SUCCESS") {
    //     // PtsAlert.success(output.message);
    //     this.setState({
    //       newUrl: "",
    //       currentFile: null,
    //       fileType: "",
    //       fileName: "",
    //       showFileView: false,
    //       selectedBanner: { name: "" },
    //     });
    //   } else {
    //   }

    // });

    this.setState({
      imagePreview: null,
      showFileView: false,
      newUrl: "",
      fileType: "",
      fileName: "",
      selectedBanner: { name: "" },
      currentFile: null,
      bannerImage: null,
    });
  }
  deleteBackgroundImageInBackend() {
    this.setState({
      backgroundImagePreview: null,
      showBackgroundImageView: false,
      backgroundImageUrl: null,
      backgroundImageType: "",
      backgroundImageName: "",
      selectedBackgroundImage: { name: "" },
      backgroundImage: null,
    });
  }
  handleDonationOpen(rowData) {
    this.setState({
      donationOpen: true,
      donationId: rowData.id,
    });
  }
  handleDonationClose() {
    this.setState({
      donationOpen: false,
    });
  }
  handleBannerTextChange(e) {
    this.setState({
      bannerText: e.target.value,
    });
  }

  safeNum = (val) => {
    const n = Number(val);
    return Number.isFinite(n) ? n : "";
  };

  handleBannerBackgroundColorChange(e) {
    this.setState({ bannerBackground: e.target.value });
  }
  handlebannerTextColorChanges(e) {
    this.setState({ bannerTextColor: e.target.value });
  }
  getSafeColor(color) {
    if (!color) return "transparent";
    return color.startsWith("#") ? color : `#${color}`;
  }

  handleDonationUrlChange(e) {
    this.setState({ donationUrl: e.target.value });
  }

  handleMeterFontColorChange = (event) => {
    const color = event.target.value;
    this.setState({ meterFontColor: color });
  };

  handleTextColorChange = (event) => {
    const color = event.target.value;
    this.setState({ bannerTextColor: color });
  };

  handleBgColorChange = (event) => {
    const color = event.target.value;
    this.setState({ bannerBackground: color });
  };

  render() {
    this.logoUploadRef = React.createRef();
    this.BackgroundImageUploadRef = React.createRef();
    this.fileUploadRef = React.createRef();
    this.donationAmountRef = React.createRef();
    const percentage = Math.min(
      (this.state.totalDonation / this.state.fundraisingGoal) * 100,
      100
    );
    const { bannerBackground, bannerTextColor, meterFontColor } = this.state;
    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <>
          <MenuWithBreadScrum
            breadCrumb={this.breadCrumb}
            navigate={this.props.navigate}
            backCallback={this.viewCancel.bind(this)}
            domainObject={
              Utils.equalsIgnoreCase(
                this.state.messageType?.type,
                MESSAGE_TYPES.standard
              ) ||
                Utils.equalsIgnoreCase(
                  this.state.messageType?.type,
                  MESSAGE_TYPES.fundraising
                )
                ? "Donation Meter Setup"
                : "Pledge meter setup"
            }
            name={
              Utils.equalsIgnoreCase(
                this.state.messageType?.type,
                MESSAGE_TYPES.standard
              ) ||
                Utils.equalsIgnoreCase(
                  this.state.messageType?.type,
                  MESSAGE_TYPES.fundraising
                )
                ? "Donation Meter Setup"
                : "Pledge meter setup"
            }
          />
          <div className="row" style={{ marginTop: "1em" }}>
            <div className="col-md-12">
              <div className="row mb-1">
                <label
                  className="form-label fs-5 fw-bold"
                  htmlFor="collapsible-firstname"
                >
                  Giving Meter Editor for Message:
                  <span className="hedding ms-1">{this.state.messageName}</span>
                </label>
              </div>
              <div className="row d-flex justify-content-start mt-3">
                <div className="col-md-6">
                  <div className="card" id="giveBeeCard">
                    {/* <div className="row text-end">
                      <span
                        className="cursor-pointer anchortag"
                        style={{ fontSize: "12px" }}
                        onClick={this.onCopy}
                      >
                        Copy embed code for this meter to my clipboard.
                      </span>
                      {this.state.alertVisible && (
                        <span
                          className="pledgeCopyToClipboard ms-auto text-end"
                          style={{
                            width: "190px",
                            marginLeft: "430px",
                          }}
                        >
                          iFrame code copied to clipboard!
                        </span>
                      )}
                    </div> */}
                    <div
                      className="card-header d-flex align-items-start justify-content-between pt-1"
                      id="assetCardHeader"
                    >
                      <h6 className="mb-0" id="headerLabel">
                        Meter Settings
                      </h6>
                    </div>
                    <div className="card-body pb-0">
                      <div className="row">
                        <div className="col-md-9">
                          <div className="row d-flex">
                            <div className="col-md-3">
                              <label className="form-label">
                                <b>Banner Text</b>
                                <span
                                  className="p-0 ms-1"
                                  style={{
                                    fontWeight: "normal",
                                    fontSize: "11px",
                                    color: "black",
                                  }}
                                ></span>
                              </label>
                            </div>
                            <div
                              className="col-md-9  bannertextEditor justify-content-end"
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              {/* <BannerColorPicker
                                key={`${bannerTextColor}-${bannerBackground}`}
                                textColor={bannerTextColor}
                                backgroundColor={bannerBackground}
                                onTextColorChange={(color) =>
                                  this.setState({ bannerTextColor: color })
                                }
                                onBackgroundChange={(color) =>
                                  this.setState({ bannerBackground: color })
                                }
                              /> */}
                              <div className="wrapper">
                                <div className="color-box-container">
                                  <input
                                    type="color"
                                    value={this.state.bannerTextColor}
                                    onInput={(e) => {
                                      this.handleTextColorChange(e);
                                    }}
                                    onChange={(e) => {
                                      this.handleTextColorChange(e);
                                      e.target.blur();
                                    }}
                                    className="color-input"
                                  />
                                  <FormatColorTextIcon className="icon-overlay" />
                                </div>

                                {/* Background Color Picker */}
                                <div className="color-box-container">
                                  <input
                                    type="color"
                                    value={bannerBackground}
                                    onChange={this.handleBgColorChange}
                                    className="color-input"
                                  />
                                  <BorderColorIcon className="icon-overlay" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <input
                            title=""
                            ref={this.textareaRef}
                            value={this.state.bannerText}
                            onChange={this.handleBannerTextChange.bind(this)}
                            className="banner-form-control"
                            id="BannerText"
                            style={{
                              overflow: "hidden",
                              resize: "none",
                              color: this.state.bannerTextColor,
                              background: this.state.bannerBackground,
                            }}
                          />
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-sm-6 m-0" id="givbeeText">
                          <div className="row justify-content-end">
                            <div className="col-sm-12">
                              <Autocomplete
                                id="size-small-outlined"
                                size="small"
                                fullWidth
                                disableClearable
                                autoComplete="off"
                                ListboxProps={{
                                  className: "custom-listbox",
                                }}
                                options={this.state.displayTypeList}
                                value={this.state.displayType}
                                getOptionLabel={(option) => option.description}
                                defaultValue={this.state.displayType}
                                onChange={(event, value) => {
                                  this.handleDisplayTypeChange(value);
                                }}
                                inputprops={{
                                  style: { textTransform: "capitalize" },
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Please Select"
                                    variant="outlined"
                                    size="small"
                                    className="autoComplete"
                                    required
                                    title=""
                                    style={{ background: "#fff" }}
                                  />
                                )}
                              />
                            </div>
                          </div>
                          <div className="row mt-3 justify-content-end">
                            <label
                              className="col-sm-5 form-label fw-bold text-end align-self-center"
                              htmlFor="collapsible-style"
                            >
                              Style
                            </label>
                            <div className="col-sm-7">
                              <Autocomplete
                                id="size-small-outlined"
                                size="small"
                                fullWidth
                                disableClearable
                                autoComplete="off"
                                ListboxProps={{
                                  className: "custom-listbox",
                                }}
                                options={this.state.displayStyles}
                                value={this.state.displayStyle}
                                getOptionLabel={(option) => option.description}
                                defaultValue={this.state.displayStyle}
                                onChange={(event, value) => {
                                  this.handleMeterStyleChange(value);
                                }}
                                inputprops={{
                                  style: { textTransform: "capitalize" },
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Please Select"
                                    variant="outlined"
                                    size="small"
                                    className="autoComplete"
                                    required
                                    title=""
                                    style={{ background: "#fff" }}
                                  />
                                )}
                              />
                            </div>
                          </div>
                          {this.state.displayStyle?.name !== "Ticker" &&
                            <>
                              <div
                                className="row justify-content-end"
                                style={{ marginTop: "12px" }}
                              >
                                <label
                                  className="col-sm-5 form-label fw-bold text-end align-self-center"
                                  htmlFor="collapsible-style"
                                >
                                  Goal
                                </label>

                                <div className="col-sm-7 d-flex">
                                  <span
                                    className="input-group-addon align-content-center inputFundraising"
                                    style={{ width: "40px" }}
                                  >
                                    $
                                  </span>
                                  <input
                                    type="number"
                                    autoComplete="off"
                                    id="multiStepsFirstName"
                                    name="multiStepsFirstName"
                                    className="form-control"
                                    style={{
                                      // textAlign: "end",
                                      borderRadius: " 0rem 0.375rem 0.375rem 0rem",
                                    }}
                                    value={this.state.fundraisingGoal}
                                    onChange={this.handleFundraisingGoalChange.bind(
                                      this
                                    )}
                                    onFocus={(event) => {
                                      event.target.select();
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="row mt-3 justify-content-end">
                                <label
                                  className="col-sm-5 form-label fw-bold text-end align-self-center"
                                  htmlFor="collapsible-style"
                                >
                                  Measure
                                </label>
                                <div className="col-sm-7">
                                  <Autocomplete
                                    id="size-small-outlined"
                                    size="small"
                                    fullWidth
                                    disableClearable
                                    autoComplete="off"
                                    ListboxProps={{
                                      className: "custom-listbox",
                                    }}
                                    options={this.state.measureTypes}
                                    value={this.state.measureType}
                                    getOptionLabel={(option) => option.type}
                                    defaultValue={this.state.measureType}
                                    onChange={(event, value) => {
                                      this.handleMeasureTypeChange(value);
                                    }}
                                    inputprops={{
                                      style: { textTransform: "capitalize" },
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Please Select"
                                        variant="outlined"
                                        size="small"
                                        className="autoComplete"
                                        required
                                        title=""
                                        style={{ background: "#fff" }}
                                      />
                                    )}
                                  />
                                </div>
                              </div>
                            </>
                          }
                          {this.state.displayStyle?.name !== "Ticker" &&
                            this.state.displayStyle?.name !== "Speedometer" && (
                              <div className="row mt-3 justify-content-end">
                                <label
                                  className="col-sm-5 form-label fw-bold text-end align-self-center"
                                  htmlFor="collapsible-style"
                                >
                                  Color
                                </label>
                                <div className="col-sm-7">
                                  <Select
                                    value={this.state.displayColor?.id}
                                    onChange={(event) =>
                                      this.handleColorChange(event)
                                    }
                                    className="selectColorCode action-button"
                                    style={{
                                      backgroundColor: this.getSafeColor(
                                        this.state.displayColor?.hashColor
                                      ),
                                      border: "1px solid #a6adb4",
                                      height: "36px",
                                      width: "36px",
                                    }}
                                    renderValue={() => null}
                                    MenuProps={{
                                      PaperProps: {
                                        style: {
                                          maxHeight: 250,
                                          overflowY: "auto",
                                        },
                                      },
                                      MenuListProps: {
                                        className: "colorMenuListWrap",
                                      },
                                      anchorOrigin: {
                                        vertical: "bottom",
                                        horizontal: "left",
                                      },
                                      transformOrigin: {
                                        vertical: "top",
                                        horizontal: "left",
                                      },
                                    }}
                                  >
                                    {this.state.colorTypeList?.map((option) => (
                                      <MenuItem
                                        key={option.id}
                                        value={option.id}
                                        className="colorCodeMenuItem"
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          fontSize: "15px",
                                          cursor: "pointer",
                                          padding: "8px",
                                          "&:hover div": {
                                            transform: "scale(1.1)",
                                            boxShadow: "0 0 6px #e6effc",
                                            borderRadius: "3px",
                                          },
                                        }}
                                      >
                                        <div
                                          style={{
                                            backgroundColor: this.getSafeColor(
                                              option.hashColor
                                            ),
                                            width: 18,
                                            height: 18,
                                            borderRadius: "3px",
                                            border: "1px solid #ccc",
                                            transition: "all 0.2s ease-in-out",
                                          }}
                                        />
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </div>
                              </div>
                            )}
                          {/* <div className="row mt-3 justify-content-end">
                            <div className="col-sm-7  d-flex align-items-center align-self-center">
                              <span className="me-2">
                                <input
                                  type="checkbox"
                                  style={{ cursor: "pointer" }}
                                  value={this.state.isOptinkeyword}
                                  onChange={(e) => this.handleOptinKeyword(e)}
                                  checked={this.state.isOptinkeyword}
                                />
                              </span>
                              <p
                                className="form-label "
                                htmlFor="collapsible-lastname"
                                onClick={(e) => this.handleOptinKeyword(e)}
                                style={{ cursor: "pointer" }}
                              >
                                Keyword
                              </p>
                            </div>
                          </div>
                          <div className="row justify-content-end">
                            <div className="col-sm-7  d-flex align-items-center align-self-center">
                              <span className="me-2">
                                <input
                                  type="checkbox"
                                  style={{ cursor: "pointer" }}
                                  value={this.state.isAutoscroll}
                                  onChange={(e) => this.handleAutoScroll(e)}
                                  checked={this.state.isAutoscroll}
                                />
                              </span>
                              <p
                                className="form-label "
                                htmlFor="collapsible-lastname"
                                onClick={(e) => this.handleAutoScroll(e)}
                                style={{ cursor: "pointer" }}
                              >
                             Auto-scroll
                              </p>
                            </div>
                          </div> */}
                        </div>
                        <div className="col-sm-6 text-center position-relative align-self-center">
                          <>
                            {this.state.isConfetti && (
                              <div
                                className="confetti-container"
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  width: "100%",
                                  height: "100%",
                                  overflow: "hidden",
                                  pointerEvents: "none",
                                }}
                              >
                                <Confetti
                                  gravity={0.1}
                                  wind={0}
                                  numberOfPieces={200}
                                  width={350} // Restrict width
                                  height={400} // Restrict height
                                />
                              </div>
                            )}
                            {this.state.displayStyle?.name === "Wide Meter" && (
                              <>
                                <Container sx={{ textAlign: "center" }}>
                                  <Box
                                    sx={{
                                      top: "4px",
                                      height: "41px",
                                      width: "61.8px",
                                      left: "90px",
                                      zIndex: "999",
                                      background: "#ddd",
                                      borderRadius: "50px 50px 0px 0px",
                                      position: "relative",
                                      overflow: "hidden",
                                      display: "flex",
                                      flexDirection: "column-reverse",
                                      border: "12px solid #ccc",
                                      borderBottom: "none",
                                      transform: "rotateX(10deg)",
                                      transformStyle: "preserve-3d",
                                      perspective: "1000px",
                                      boxShadow: this.state.is3dEffect
                                        ? "inset 10px 0 8px -6px rgba(0, 0, 0, 0.4),inset -10px 0 8px -6px rgba(0, 0, 0, 0.4)"
                                        : "none",
                                    }}
                                  ></Box>
                                  <Box
                                    sx={{
                                      textAlign: "center",
                                      position: "relative",
                                      height: "220px",
                                    }}
                                  >
                                    {/* Goal Labels */}
                                    {this.state.isShowGoalAmount && (
                                      <Box
                                        sx={{
                                          position: "absolute",
                                          textAlign: "right",
                                          right: "64%",
                                          top: "0px",
                                          display: "flex",
                                          flexDirection: "column",
                                          justifyContent: "space-between",
                                          height: "150px",
                                          color: "#353538",
                                          fontWeight: "800",
                                        }}
                                      >
                                        {this.state.measureType?.type ===
                                          "% Meter" ? (
                                          <>
                                            {[1, 0.8, 0.6, 0.4, 0.2, 0].map(
                                              (value, index) => {
                                                const amount =
                                                  this.state.fundraisingGoal *
                                                  value;
                                                return (
                                                  <Typography
                                                    key={index}
                                                    variant="body2"
                                                    sx={{
                                                      fontSize: [
                                                        "12px",
                                                        "!important",
                                                      ],
                                                      visibility:
                                                        amount === 0
                                                          ? "hidden"
                                                          : "visible",
                                                    }}
                                                  >
                                                    {`${(value * 100).toFixed(
                                                      0
                                                    )}%`}
                                                  </Typography>
                                                );
                                              }
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            {[1, 0.8, 0.6, 0.4, 0.2, 0].map(
                                              (value, index) => {
                                                const amount =
                                                  this.state.fundraisingGoal *
                                                  value;
                                                return (
                                                  <span
                                                    key={index}
                                                    variant="body2"
                                                    style={{
                                                      fontSize: "12px",
                                                      fontWeight: "400",
                                                      visibility:
                                                        amount === 0
                                                          ? "hidden"
                                                          : "visible",
                                                    }}
                                                  >
                                                    $
                                                    {Utils.formatCompactNumber(
                                                      amount
                                                    )}
                                                  </span>
                                                );
                                              }
                                            )}
                                          </>
                                        )}
                                      </Box>
                                    )}
                                    {/* Thermometer Container */}
                                    <Box
                                      sx={{
                                        height: "150px",
                                        width: "62px",
                                        left: "90px",
                                        zIndex: "1",
                                        background: "#ddd",
                                        position: "relative",
                                        overflow: "hidden",
                                        display: "flex",
                                        flexDirection: "column-reverse",
                                        border: "12px solid #ccc",
                                        borderBottom: "none",
                                        borderTop: "none",
                                        boxShadow: this.state.is3dEffect
                                          ? "inset 10px 0 8px -6px rgba(0, 0, 0, 0.4),inset -10px 0 8px -6px rgba(0, 0, 0, 0.4)"
                                          : "none",
                                      }}
                                    >
                                      {/* Mercury Level */}
                                      {this.state.isShowGoalAmount && (
                                        <Box
                                          sx={{
                                            position: "absolute",
                                            left: "-15px",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-between",
                                            height: "150px",
                                            color: "#fff",
                                            fontWeight: "800",
                                          }}
                                        >
                                          {[...Array(50)].map((_, index) => (
                                            <Box
                                              key={index}
                                              sx={{
                                                position: "absolute",
                                                bottom: `${index * 4}%`, // 5% interval
                                                left: "10px",
                                                width:
                                                  index % 5 === 0
                                                    ? "16px"
                                                    : "10px",
                                                height:
                                                  index % 5 === 0
                                                    ? "1px"
                                                    : "0.5px",
                                                background: "#000",
                                                opacity:
                                                  index % 5 === 0 ? 0.8 : 0.6,
                                              }}
                                            />
                                          ))}
                                        </Box>
                                      )}
                                      <Box
                                        sx={{
                                          width: "100%",
                                          background: this.getSafeColor(
                                            this.state.displayColor?.hashColor
                                          ),
                                          transition: "height 1.5s ease-in-out",
                                          height: `${Math.min(
                                            (this.state.totalDonation /
                                              this.state.fundraisingGoal) *
                                            100,
                                            100
                                          )}%`,
                                          boxShadow: this.state.is3dEffect
                                            ? "inset 10px 0 8px -6px rgba(0, 0, 0, 0.4),inset -10px 0 8px -6px rgba(0, 0, 0, 0.4)"
                                            : "nane",
                                        }}
                                      />
                                    </Box>
                                    <Box
                                      sx={{
                                        width: "100px",
                                        height: "100px",
                                        background: this.getSafeColor(
                                          this.state.displayColor?.hashColor
                                        ),
                                        borderRadius: "50%",
                                        border: "12px solid #ccc",
                                        position: "relative",
                                        top: "-18px",
                                        left: "121px",
                                        transform: "translateX(-50%)",
                                        boxShadow: this.state.is3dEffect
                                          ? "inset -4px 0 8px rgba(0, 0, 0, 0.4), inset 4px 0 8px rgba(0, 0, 0, 0.4)"
                                          : "none",

                                        // boxShadow: "inset 0 0 25px 10px rgba(255, 255, 200, 0.6)", // Inner glow effect
                                        "&::before": {
                                          content: '""', // ✅ Required for ::before to show
                                          position: "absolute",
                                          top: "16%",
                                          left: "5%",
                                          width: "60%",
                                          height: "47%",
                                          background:
                                            "radial-gradient(circle, rgba(255,255,255,0.7) 0%, transparent 90%)",
                                          clipPath:
                                            "ellipse(60% 60% at 60% 60%)",
                                          borderRadius: "50%",
                                          filter: "blur(1px)",
                                          transform: "rotate(-47deg)",
                                          zIndex: 2,
                                        },
                                      }}
                                    />
                                  </Box>
                                </Container>
                              </>
                            )}
                            {this.state.displayStyle?.name ===
                              "Skinny Meter" && (
                                <>
                                  <Container sx={{ textAlign: "center" }}>
                                    <Box
                                      sx={{
                                        top: "4px",
                                        height: "34px",
                                        width: "45.8px",
                                        left: "98px",
                                        zIndex: "999",
                                        background: "#ddd",
                                        borderRadius: "50px 50px 0px 0px",
                                        position: "relative",
                                        overflow: "hidden",
                                        display: "flex",
                                        flexDirection: "column-reverse",
                                        border: "10px solid #ccc",
                                        borderBottom: "none",
                                        transform: "rotateX(10deg)",
                                        transformStyle: "preserve-3d",
                                        perspective: "1000px",
                                        boxShadow: this.state.is3dEffect
                                          ? "inset 10px 0 8px -6px rgba(0, 0, 0, 0.4),inset -10px 0 8px -6px rgba(0, 0, 0, 0.4)"
                                          : "none",
                                      }}
                                    ></Box>
                                    <Box
                                      sx={{
                                        textAlign: "center",
                                        position: "relative",
                                        height: "220px",
                                      }}
                                    >
                                      {this.state.isShowGoalAmount && (
                                        <Box
                                          sx={{
                                            position: "absolute",
                                            textAlign: "right",
                                            right: "62%",
                                            top: "0px",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-between",
                                            height: "175px",
                                            color: "#353538",
                                            fontWeight: "800",
                                          }}
                                        >
                                          {this.state.measureType?.type ===
                                            "% Meter" ? (
                                            <>
                                              {[1, 0.8, 0.6, 0.4, 0.2, 0].map(
                                                (value, index) => {
                                                  const amount =
                                                    this.state.fundraisingGoal *
                                                    value;
                                                  return (
                                                    <Typography
                                                      key={index}
                                                      variant="body2"
                                                      sx={{
                                                        fontSize: [
                                                          "12px",
                                                          "!important",
                                                        ],
                                                        visibility:
                                                          amount === 0
                                                            ? "hidden"
                                                            : "visible",
                                                      }}
                                                    >
                                                      {`${(value * 100).toFixed(
                                                        0
                                                      )}%`}
                                                    </Typography>
                                                  );
                                                }
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {[1, 0.8, 0.6, 0.4, 0.2, 0].map(
                                                (value, index) => {
                                                  const amount =
                                                    this.state.fundraisingGoal *
                                                    value;
                                                  return (
                                                    <span
                                                      key={index}
                                                      variant="body2"
                                                      style={{
                                                        fontSize: "12px",
                                                        fontWeight: "400",
                                                        visibility:
                                                          amount === 0
                                                            ? "hidden"
                                                            : "visible",
                                                      }}
                                                    >
                                                      $
                                                      {Utils.formatCompactNumber(
                                                        amount
                                                      )}
                                                    </span>
                                                  );
                                                }
                                              )}
                                            </>
                                          )}
                                        </Box>
                                      )}
                                      <Box
                                        sx={{
                                          height: "175px",
                                          width: "46px",
                                          left: "98px",
                                          zIndex: "999",
                                          background: "#ddd",
                                          position: "relative",
                                          overflow: "hidden",
                                          display: "flex",
                                          flexDirection: "column-reverse",
                                          border: "10px solid #ccc",
                                          borderBottom: "none",
                                          borderTop: "none",
                                          clipPath:
                                            "polygon(0 0, 100% 0, 100% 98%, 50% 100%, 0 98%)",
                                          boxShadow: this.state.is3dEffect
                                            ? "inset 10px 0 8px -6px rgba(0, 0, 0, 0.4),inset -10px 0 8px -6px rgba(0, 0, 0, 0.4)"
                                            : "none",
                                        }}
                                      >
                                        {this.state.isShowGoalAmount && (
                                          <Box
                                            sx={{
                                              position: "absolute",
                                              left: "-15px",
                                              display: "flex",
                                              flexDirection: "column",
                                              justifyContent: "space-between",
                                              height: "175px",
                                              color: "#fff",
                                              fontWeight: "800",
                                            }}
                                          >
                                            {[...Array(50)].map((_, index) => (
                                              <Box
                                                key={index}
                                                sx={{
                                                  position: "absolute",
                                                  bottom: `${index * 4}%`, // 5% interval
                                                  left: "10px",
                                                  width:
                                                    index % 5 === 0
                                                      ? "16px"
                                                      : "10px",
                                                  height:
                                                    index % 5 === 0
                                                      ? "1px"
                                                      : "0.5px",
                                                  background: "#000",
                                                  opacity:
                                                    index % 5 === 0 ? 0.8 : 0.6,
                                                }}
                                              />
                                            ))}
                                          </Box>
                                        )}
                                        <Box
                                          sx={{
                                            width: "100%",
                                            background: this.getSafeColor(
                                              this.state.displayColor?.hashColor
                                            ),

                                            transition: "height 1.5s ease-in-out",
                                            height: `${Math.min(
                                              (this.state.totalDonation /
                                                this.state.fundraisingGoal) *
                                              100,
                                              100
                                            )}%`,
                                            boxShadow: this.state.is3dEffect
                                              ? "inset -4px 0 8px rgba(0, 0, 0, 0.4),inset 4px 0 8px rgba(0, 0, 0, 0.4),-4px 0 8px rgba(0, 0, 0, 0.6),4px 0 8px rgba(0, 0, 0, 0.4)"
                                              : "none",
                                          }}
                                        />
                                      </Box>
                                      <Box
                                        sx={{
                                          width: "75px",
                                          height: "75px",
                                          background: this.getSafeColor(
                                            this.state.displayColor?.hashColor
                                          ),
                                          borderRadius: "50%",
                                          border: "10px solid #ccc",
                                          position: "relative",
                                          top: "-15px",
                                          left: "120px",
                                          transform: "translateX(-50%)",
                                          boxShadow: this.state.is3dEffect
                                            ? "inset -4px 0 8px rgba(0, 0, 0, 0.4), inset 4px 0 8px rgba(0, 0, 0, 0.4)"
                                            : "none",
                                          "&::before": {
                                            content: '""', // ✅ Required for ::before to show
                                            position: "absolute",
                                            top: "11%",
                                            left: "8%",
                                            width: "86%",
                                            height: "60%",
                                            background:
                                              "radial-gradient(circle, rgba(255,255,255,0.7) 0%, transparent 90%)",
                                            clipPath:
                                              "ellipse(40% 40% at 40% 40%)",
                                            borderRadius: "50%",
                                            filter: "blur(1px)",
                                            transform: "rotate(-33deg)",
                                            zIndex: 2,
                                          },
                                        }}
                                      />
                                    </Box>
                                  </Container>
                                </>
                              )}
                            {this.state.displayStyle?.name ===
                              "HorizontalBar" && (
                                <>
                                  <Container sx={{ textAlign: "center" }}>
                                    <HorizontalBar
                                      goal={this.state.fundraisingGoal}
                                      raised={this.state.totalDonation}
                                      color={this.getSafeColor(
                                        this.state.displayColor?.hashColor
                                      )}
                                      displayType={this.state.displayStyle?.name}
                                      isShowGoalAmount={
                                        this.state.isShowGoalAmount
                                      }
                                      is3dEffect={this.state.is3dEffect}
                                      measureType={this.state.measureType}
                                      pageId="Pledge"
                                    />
                                  </Container>
                                </>
                              )}
                            {this.state.displayStyle?.name ===
                              "Speedometer" && (
                                <>
                                  <span className="pledgeSpeedometer">
                                    <ReactSpeedometer
                                      labelFontSize="12px"
                                      valueTextFontSize="16px"
                                      key={`${this.state.totalDonation}-${this.state.fundraisingGoal}-${this.state.measureType?.type}`}
                                      minValue={0}
                                      maxValue={
                                        this.state.measureType?.type === "% Meter"
                                          ? 100
                                          : this.safeNum(
                                            this.state.fundraisingGoal
                                          )
                                      }
                                      value={
                                        this.state.measureType?.type === "% Meter"
                                          ? Math.min(percentage, 100)
                                          : Math.min(
                                            this.safeNum(
                                              this.state.totalDonation
                                            ),
                                            this.safeNum(
                                              this.state.fundraisingGoal
                                            )
                                          )
                                      }
                                      segmentColors={[
                                        "#86cf34",
                                        "#eaf03a",
                                        "#f09c24",
                                        "#f44336",
                                      ]}
                                      segments={4}
                                      maxSegmentLabels={
                                        this.state.isShowGoalAmount ? 5 : 0
                                      }
                                      segmentValueFormatter={(val) =>
                                        this.state.measureType?.type === "% Meter"
                                          ? `${val.toLocaleString()}%`
                                          : `$${this.safeNum(
                                            val
                                          )?.toLocaleString()}`
                                      }
                                      currentValueText={`Raised: $${this.safeNum(
                                        this.state.totalDonation
                                      )?.toLocaleString()}`} // still shows actual raised
                                      width={300}
                                      height={200}
                                      needleColor="#666666"
                                      ringWidth={30}
                                    />
                                  </span>
                                </>
                              )}
                            {this.state.displayStyle?.name === "Ticker" && (
                              <>
                                <div
                                  className="row ms-2"
                                  style={{
                                    textAlign: "center",
                                    background: "#39b54a",
                                    height: "180px",
                                    width: "258px",
                                    position: "relative",
                                    overflow: "hidden", // Prevents content overflow
                                    display: "flex",
                                    alignItems: "flex-end",
                                  }}
                                >
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: "42%",
                                      left: "50%",
                                      transform: "translate(-50%, -50%)",
                                      // fontWeight: "bold",
                                      color: "#ffff",
                                      fontSize: "18px",
                                      textAlign: "center",
                                      padding: "0 31px",
                                      zIndex: 1,
                                    }}
                                  >
                                    Display your own image, slideshow or video
                                    on this green screen.
                                  </div>
                                  <div
                                    className="col-sm-12 d-flex align-items-center"
                                    style={{
                                      width: "100%",
                                      backgroundColor: bannerBackground,
                                      padding: "10px",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "20px",
                                        fontSize: "20px",
                                        fontWeight: "700",
                                        color: bannerTextColor,
                                        animation:
                                          "scrollLeft 20s linear infinite",
                                      }}
                                    >
                                      {[
                                        ...(this.state.bannerText
                                          ? [
                                            {
                                              firstName: this.state.bannerText,
                                              isBanner: true,
                                            },
                                          ]
                                          : []),
                                        ...this.state.sampleDonationList,
                                      ]
                                        .concat(this.state.sampleDonationList)
                                        .map((item, index) => (
                                          <span key={index}>
                                            {item.isBanner
                                              ? item.firstName
                                              : `${item.firstName} ${item.lastName}`}{" "}
                                            {!item.isBanner && `$${item.amount}`}{" "}
                                            &nbsp;&nbsp;
                                          </span>
                                        ))}
                                    </div>
                                  </div>
                                </div>
                                <div className="text-end me-4">
                                  {" "}
                                  <span
                                    className="anchortag"
                                    style={{ fontSize: "12px" }}
                                    onClick={this.handleTickerOverlayDilogboxOpen.bind(
                                      this
                                    )}
                                  >
                                    <u>How it works</u>
                                  </span>
                                </div>
                              </>
                            )}
                          </>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-sm-6 m-0" id="givbeeText">
                          {!["Ticker"].includes(
                            this.state.displayStyle?.name
                          ) && (
                              <div className="row justify-content-end">
                                <div className="col-sm-7  d-flex align-items-center align-self-center">
                                  <span className="me-2">
                                    <input
                                      type="checkbox"
                                      style={{
                                        cursor: "pointer",
                                      }}
                                      value={this.state.isShowGoalAmount}
                                      onChange={this.handleMeterGoal.bind(this)}
                                      checked={this.state.isShowGoalAmount}
                                    />
                                  </span>
                                  <p
                                    className="form-label mb-0"
                                    htmlFor="collapsible-lastname"
                                    onClick={this.handleMeterGoal.bind(this)}
                                    style={{
                                      cursor: "pointer",
                                    }}
                                  >
                                    Meter/Goal
                                  </p>
                                </div>
                              </div>
                            )}
                          {!["Speedometer", "Ticker"].includes(
                            this.state.displayStyle?.name
                          ) && (
                              <div className="row justify-content-end">
                                <div className="col-sm-7 d-flex align-items-center align-self-center">
                                  <input
                                    type="checkbox"
                                    style={{
                                      cursor: "pointer",
                                    }}
                                    value={this.state.is3dEffect}
                                    onChange={this.handle3dEffectThermometer.bind(
                                      this
                                    )}
                                    checked={this.state.is3dEffect}
                                  />
                                  <p
                                    className="form-label ms-2 mb-0"
                                    onClick={this.handle3dEffectThermometer.bind(
                                      this
                                    )}
                                    style={{
                                      cursor: ["Speedometer", "Ticker"].includes(
                                        this.state.displayStyle?.name
                                      )
                                        ? "default"
                                        : "pointer",
                                    }}
                                  >
                                    3D Effect
                                  </p>
                                </div>
                              </div>
                            )}
                          {!["Ticker"].includes(
                            this.state.displayStyle?.name
                          ) && (
                              <div className="row justify-content-end">
                                <div className="col-sm-7 d-flex align-items-center align-self-center">
                                  <input
                                    type="checkbox"
                                    style={{
                                      cursor: "pointer",
                                    }}
                                    value={this.state.isConfetti}
                                    onChange={this.handleConfettiThermometer.bind(
                                      this
                                    )}
                                    checked={this.state.isConfetti}
                                  />
                                  <p
                                    className="form-label ms-2 mb-0"
                                    onClick={this.handleConfettiThermometer.bind(
                                      this
                                    )}
                                    style={{
                                      cursor: "pointer",
                                    }}
                                  >
                                    Confetti
                                  </p>
                                </div>
                              </div>
                            )}
                          {/* <div className="row justify-content-end">
                            <div className="col-sm-7  d-flex align-items-center align-self-center">
                              <span className="me-2">
                                <input
                                  type="checkbox"
                                  style={{
                                    cursor: ["Ticker"].includes(
                                      this.state.displayStyle?.name
                                    )
                                      ? "default"
                                      : "pointer",
                                  }}
                                  value={this.state.isOptinkeyword}
                                  onChange={this.handleOptinKeyword.bind(this)}
                                  checked={this.state.isOptinkeyword}
                                  disabled={["Ticker"].includes(
                                    this.state.displayStyle?.name
                                  )}
                                />
                              </span>
                              <p
                                className="form-label "
                                htmlFor="collapsible-lastname"
                                onClick={
                                  !["Ticker"].includes(
                                    this.state.displayStyle?.name
                                  )
                                    ? this.handleOptinKeyword.bind(this)
                                    : undefined
                                }
                                style={{
                                  cursor: ["Ticker"].includes(
                                    this.state.displayStyle?.name
                                  )
                                    ? "default"
                                    : "pointer",
                                }}
                              >
                                QR Code
                              </p>
                            </div>
                          </div> */}
                          {/* <div className="row justify-content-end">
                            <div className="col-sm-7  d-flex align-items-center align-self-center">
                              <span className="me-2">
                                <input
                                  type="checkbox"
                                  style={{ cursor: "pointer" }}
                                  value={this.state.isAutoscroll}
                                  onChange={(e) => this.handleAutoScroll(e)}
                                  checked={this.state.isAutoscroll}
                                />
                              </span>
                              <p
                                className="form-label "
                                htmlFor="collapsible-lastname"
                                onClick={(e) => this.handleAutoScroll(e)}
                                style={{ cursor: "pointer" }}
                              >
                                Auto-scroll
                              </p>
                            </div>
                          </div> */}
                        </div>
                        {/* <div className="col-sm-6 text-center position-relative align-self-end pt-2">
                          {(this.state.displayStyle?.name === "Wide Meter" ||
                            this.state.displayStyle?.name ===
                              "Skinny Meter") && (
                            <>
                              <a
                                href={`/launchThermometer?t=${this.header?.tid}&p=${this.state.pledgeId}`}
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                  color: "#fff",
                                }}
                              >
                                <Button
                                  type="submit"
                                  variant="contained"
                                  style={{
                                    padding: "6px 15px",
                                    background: "#5ac489",
                                    color: "#fff",
                                    textTransform: "capitalize",
                                    fontWeight: "600",
                                    fontSize: "16px",
                                  }}
                                  onClick={this.UpdatePledgeDataToBackend.bind(
                                    this
                                  )}
                                >
                                  Save & Launch
                                </Button>
                              </a>
                            </>
                          )}
                          {this.state.displayStyle?.name ===
                            "HorizontalBar" && (
                            <>
                              <a
                                href={`/launchThermometer?t=${this.header?.tid}&p=${this.state.pledgeId}`}
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                  color: "#fff",
                                }}
                              >
                                <Button
                                  type="submit"
                                  variant="contained"
                                  style={{
                                    padding: "6px 15px",
                                    background: "#5ac489",
                                    color: "#fff",
                                    textTransform: "capitalize",
                                    fontWeight: "600",
                                    fontSize: "16px",
                                  }}
                                  onClick={this.UpdatePledgeDataToBackend.bind(
                                    this
                                  )}
                                >
                                  Save & Launch
                                </Button>
                              </a>
                            </>
                          )}
                          {this.state.displayStyle?.name === "Speedometer" && (
                            <>
                              <a
                                href={`/launchThermometer?t=${this.header?.tid}&p=${this.state.pledgeId}`}
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                  color: "#fff",
                                }}
                              >
                                <Button
                                  type="submit"
                                  variant="contained"
                                  style={{
                                    padding: "6px 15px",
                                    background: "#5ac489",
                                    color: "#fff",
                                    textTransform: "capitalize",
                                    fontWeight: "600",
                                    fontSize: "16px",
                                  }}
                                  onClick={this.UpdatePledgeDataToBackend.bind(
                                    this
                                  )}
                                >
                                  Save & Launch
                                </Button>
                              </a>
                            </>
                          )}
                          {this.state.displayStyle?.name === "Ticker" && (
                            <>
                              <div className="row">
                                <div className="col-sm-7 text-end pe-2">
                                  <a
                                    href={`/tickerOverlay?t=${this.header?.tid}&p=${this.state.pledgeId}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{
                                      color: "#fff",
                                    }}
                                  >
                                    <Button
                                      type="submit"
                                      variant="contained"
                                      style={{
                                        padding: "6px 15px",
                                        background: "#5ac489",
                                        color: "#fff",
                                        textTransform: "capitalize",
                                        fontWeight: "600",
                                        fontSize: "16px",
                                      }}
                                    >
                                      Save & Launch
                                    </Button>
                                  </a>
                                </div>
                                <div className="col-sm-5 align-self-end text-start ps-0">
                       
                                </div>
                              </div>
                            </>
                          )}
                        </div> */}
                      </div>
                      <div className="row mt-3">
                        <div className="col-sm-10">
                          {!["Ticker"].includes(
                            this.state.displayStyle?.name
                          ) && (
                              <>
                                <div className="row">
                                  <label
                                    className="col-sm-3 form-label fw-bold text-end align-self-center mb-3"
                                    htmlFor="collapsible-style"
                                  >
                                    Logo
                                  </label>
                                  <div
                                    className="col-sm-9"
                                  // style={{ height: "65px" }}
                                  >
                                    {!this.state.showFileView ? (
                                      <>
                                        <div
                                          className="col-sm-3"
                                          style={{ width: "23%" }}
                                        ></div>
                                        <div className="col-sm-9 align-self-center p-0">
                                          <>
                                            <div
                                              className="col-sm-12 d-flex csvFile"
                                              style={{
                                                display: "inline-block",
                                                cursor: "pointer",
                                              }}
                                            >
                                              <div className="file-upload-wrapper">
                                                <label
                                                  htmlFor="file-upload-logo"
                                                  className={`customImageVideo-file-upload ${this.state.isDragging
                                                    ? "dragging"
                                                    : ""
                                                    }`}
                                                  onDrop={this.handleDrop}
                                                  onDragOver={this.handleDragOver}
                                                  onDragLeave={
                                                    this.handleDragLeave
                                                  }
                                                >
                                                  <CloudUploadIcon className="upload-icon" />
                                                  <span className="upload-text">
                                                    Drop file here or{" "}
                                                    <span className="browse-link">Browse for file</span>
                                                  </span>

                                                  <input
                                                    required
                                                    id="file-upload-logo"
                                                    type="file"
                                                    ref={this.logoUploadRef}
                                                    onChange={
                                                      this.handleFileChange
                                                    }
                                                    onClick={(e) => {
                                                      e.target.value = null;
                                                      this.setState({
                                                        imageError: "",
                                                        selectedBanner: {
                                                          name: "",
                                                        },
                                                      });
                                                    }}
                                                  />
                                                </label>

                                                <small className="upload-note">
                                                  Add PNG, JPG, GIF, Max 400×100
                                                  pix
                                                </small>
                                              </div>
                                            </div>
                                          </>
                                        </div>
                                        {/* {this.state.currentFile &&
                                    !this.state.imageError && (
                                      <div className="mt-2 p-0">
                                        <img
                                          style={{
                                            maxWidth: "100%",
                                            height: "4em",
                                            objectFit: "contain",
                                            objectPosition: "left",
                                          }}
                                          alt=""
                                          src={
                                            this.state.currentFile
                                              ? this.state.currentFile
                                              : ""
                                          }
                                        />
                                      </div>
                                    )} */}
                                        <span
                                          style={{ color: "red", padding: "0px" }}
                                        >
                                          {this.state.imageError}
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        <div
                                          className="col-sm-3"
                                          style={{ width: "23%" }}
                                        ></div>
                                        <div className="col-sm-9 ps-0 d-flex align-self-center">
                                          <img
                                            src={this.state.newUrl}
                                            alt=""
                                            style={{
                                              maxWidth: "100%",
                                              height: "4em",
                                              objectFit: "contain",
                                              objectPosition: "left",
                                            }}
                                          />
                                          <span className="fw-bold ms-1">
                                            <ClearIcon
                                              className="logoDelete"
                                              style={{
                                                cursor: "pointer",
                                                borderRadius: "50%",
                                                border: "solid 2px",
                                              }}
                                              onClick={this.deletePledgeBannerInBackend.bind(
                                                this
                                              )}
                                            />
                                          </span>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                                <div className="row mt-3">
                                  <label
                                    className="col-sm-3 form-label fw-bold text-end align-self-center ps-0 mb-3"
                                    htmlFor="collapsible-style"
                                  >
                                    Background
                                  </label>
                                  <div
                                    className="col-sm-9"
                                  // style={{ height: "65px" }}
                                  >
                                    {!this.state.showBackgroundImageView ? (
                                      <>
                                        <div
                                          className="col-sm-3"
                                          style={{ width: "23%" }}
                                        ></div>
                                        <div className="col-sm-9 align-self-center p-0">
                                          <>
                                            <div
                                              className="col-sm-12 d-flex csvFile"
                                              style={{
                                                display: "inline-block",
                                                cursor: "pointer",
                                              }}
                                            >
                                              <div className="file-upload-wrapper">
                                                <label
                                                  htmlFor="backgroundImage-upload"
                                                  className={`customImageVideo-file-upload ${this.state
                                                    .isBackgroundImageDragging
                                                    ? "dragging"
                                                    : ""
                                                    }`}
                                                  onDrop={
                                                    this.handleBackgroundImageDrop
                                                  }
                                                  onDragOver={
                                                    this
                                                      .handleBackgroundImageDragOver
                                                  }
                                                  onDragLeave={
                                                    this
                                                      .handleBackgroundImageDragLeave
                                                  }
                                                >
                                                  <CloudUploadIcon className="upload-icon" />
                                                  <span className="upload-text">
                                                    Drop file here or{" "}
                                                    <span className="browse-link">Browse for file</span>
                                                  </span>

                                                  <input
                                                    required
                                                    id="backgroundImage-upload"
                                                    type="file"
                                                    ref={
                                                      this
                                                        .BackgroundImageUploadRef
                                                    }
                                                    onChange={
                                                      this
                                                        .handleBackgroundImageChange
                                                    }
                                                    onClick={(e) => {
                                                      e.target.value = null;
                                                      this.setState({
                                                        backgroundImageError: "",
                                                        selectedBackgroundImage: {
                                                          name: "",
                                                        },
                                                      });
                                                    }}
                                                  />
                                                </label>

                                                <small className="upload-note">
                                                  Add PNG, JPG, GIF, Min 800×550
                                                  pix
                                                </small>
                                              </div>
                                            </div>
                                          </>
                                        </div>

                                        <span
                                          style={{ color: "red", padding: "0px" }}
                                        >
                                          {this.state.backgroundImageError}
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        <div
                                          className="col-sm-3"
                                          style={{ width: "23%" }}
                                        ></div>
                                        <div className="col-sm-9 ps-0 d-flex align-self-center">
                                          <img
                                            src={this.state.backgroundImageUrl}
                                            alt=""
                                            style={{
                                              maxWidth: "100%",
                                              height: "4em",
                                              objectFit: "contain",
                                              objectPosition: "left",
                                            }}
                                          />
                                          <span className="fw-bold ms-1">
                                            <ClearIcon
                                              className="logoDelete"
                                              style={{
                                                cursor: "pointer",
                                                borderRadius: "50%",
                                                border: "solid 2px",
                                              }}
                                              onClick={this.deleteBackgroundImageInBackend.bind(
                                                this
                                              )}
                                            />
                                          </span>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                                <div className="row mt-3">
                                  <label
                                    className="col-sm-3 form-label fw-bold text-end align-self-center ps-0"
                                    htmlFor="collapsible-style"
                                  >
                                    Text Color
                                  </label>
                                  <div className="col-sm-9 align-self-center">
                                    <div className="wrapper">
                                      <div className="color-box-container">
                                        <input
                                          type="color"
                                          value={meterFontColor}
                                          onChange={
                                            this.handleMeterFontColorChange
                                          }
                                          className="color-input"
                                        />
                                        <FormatColorTextIcon className="icon-overlay" />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row mt-3">
                                  <label className="col-sm-3 form-label fw-bold text-end align-self-center ps-0">
                                    <b>Donation URL</b>
                                  </label>
                                  <div className="col-sm-9">
                                    <input
                                      type="text"
                                      autoComplete="off"
                                      className="form-control"
                                      title=""
                                      required
                                      value={this.state.donationUrl}
                                      onChange={this.handleDonationUrlChange.bind(
                                        this
                                      )}
                                    />
                                  </div>
                                </div>
                              </>
                            )}

                          <div className="row mt-4">
                            <label
                              className="col-sm-3 form-label fw-bold text-end align-self-center"
                              htmlFor="collapsible-style"
                            ></label>
                            {/* <div className="col-sm-9">
                              {this.state.displayStyle?.name ===
                                "Wide Meter" && (
                                  <>
                                    <a
                                      href={`/launchWideThermometer?t=${this.header?.tid}&p=${this.state.pledgeId}`}
                                      target="_blank"
                                      rel="noreferrer"
                                      style={{
                                        color: "#fff",
                                      }}
                                    >
                                      <Button
                                        type="submit"
                                        variant="contained"
                                        style={{
                                          padding: "6px 15px",
                                          background: "#5ac489",
                                          color: "#fff",
                                          textTransform: "capitalize",
                                          fontWeight: "600",
                                          fontSize: "16px",
                                          width: "160px",
                                        }}
                                        onClick={this.UpdatePledgeDataToBackend.bind(
                                          this
                                        )}
                                      >
                                        Save & Launch
                                      </Button>
                                    </a>
                                  </>
                                )}
                              {this.state.displayStyle?.name === "Skinny Meter" && (
                                <>
                                  <a
                                    href={`/launchSkinnyThermometer?t=${this.header?.tid}&p=${this.state.pledgeId}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{
                                      color: "#fff",
                                    }}
                                  >
                                    <Button
                                      type="submit"
                                      variant="contained"
                                      style={{
                                        padding: "6px 15px",
                                        background: "#5ac489",
                                        color: "#fff",
                                        textTransform: "capitalize",
                                        fontWeight: "600",
                                        fontSize: "16px",
                                        width: "160px",
                                      }}
                                      onClick={this.UpdatePledgeDataToBackend.bind(
                                        this
                                      )}
                                    >
                                      Save & Launch
                                    </Button>
                                  </a>
                                </>
                              )}
                              {this.state.displayStyle?.name ===
                                "HorizontalBar" && (
                                  <>
                                    <a
                                      href={`/launchThermometer?t=${this.header?.tid}&p=${this.state.pledgeId}`}
                                      target="_blank"
                                      rel="noreferrer"
                                      style={{
                                        color: "#fff",
                                      }}
                                    >
                                      <Button
                                        type="submit"
                                        variant="contained"
                                        style={{
                                          padding: "6px 15px",
                                          background: "#5ac489",
                                          color: "#fff",
                                          textTransform: "capitalize",
                                          fontWeight: "600",
                                          fontSize: "16px",
                                          width: "160px",
                                        }}
                                        onClick={this.UpdatePledgeDataToBackend.bind(
                                          this
                                        )}
                                      >
                                        Save & Launch
                                      </Button>
                                    </a>
                                  </>
                                )}
                              {this.state.displayStyle?.name ===
                                "Speedometer" && (
                                  <>
                                    <a
                                      href={`/launchSpeedometer?t=${this.header?.tid}&p=${this.state.pledgeId}`}
                                      target="_blank"
                                      rel="noreferrer"
                                      style={{
                                        color: "#fff",
                                      }}
                                    >
                                      <Button
                                        type="submit"
                                        variant="contained"
                                        style={{
                                          padding: "6px 15px",
                                          background: "#5ac489",
                                          color: "#fff",
                                          textTransform: "capitalize",
                                          fontWeight: "600",
                                          fontSize: "16px",
                                          width: "160px",
                                        }}
                                        onClick={this.UpdatePledgeDataToBackend.bind(
                                          this
                                        )}
                                      >
                                        Save & Launch
                                      </Button>
                                    </a>
                                  </>
                                )}
                              {this.state.displayStyle?.name === "Ticker" && (
                                <>
                                  <div className="row">
                                    <div className="col-sm-7 text-start pe-2">
                                      <a
                                        href={`/tickerOverlay?t=${this.header?.tid}&p=${this.state.pledgeId}`}
                                        target="_blank"
                                        rel="noreferrer"
                                        style={{
                                          color: "#fff",
                                        }}
                                      >
                                        <Button
                                          type="submit"
                                          variant="contained"
                                          style={{
                                            padding: "6px 15px",
                                            background: "#5ac489",
                                            color: "#fff",
                                            textTransform: "capitalize",
                                            fontWeight: "600",
                                            fontSize: "16px",
                                            width: "160px",
                                          }}
                                          onClick={this.UpdatePledgeDataToBackend.bind(
                                            this
                                          )}
                                        >
                                          Save & Launch
                                        </Button>
                                      </a>
                                    </div>
                                    <div className="col-sm-5 align-self-end text-start ps-0"></div>
                                  </div>
                                </>
                              )}
                            </div> */}
                            <div className="col-sm-9">
                              {(() => {
                                const name = this.state.displayStyle?.name;
                                const tid = this.header?.tid;
                                const p = this.state.pledgeId;

                                let url = "";

                                if (name === "Wide Meter")
                                  url = `/launchWideThermometer?t=${tid}&p=${p}`;
                                else if (name === "Skinny Meter")
                                  url = `/launchSkinnyThermometer?t=${tid}&p=${p}`;
                                else if (name === "HorizontalBar")
                                  url = `/launchHorizontalThermometer?t=${tid}&p=${p}`;
                                else if (name === "Speedometer")
                                  url = `/launchSpeedometer?t=${tid}&p=${p}`;
                                else if (name === "Ticker")
                                  url = `/tickerOverlay?t=${tid}&p=${p}`;

                                return (
                                  url && (
                                    <a
                                      href={url}
                                      target="_blank"
                                      rel="noreferrer"
                                      style={{ color: "#fff" }}
                                    >
                                      <Button
                                        type="submit"
                                        variant="contained"
                                        style={{
                                          padding: "6px 15px",
                                          background: "#5ac489",
                                          color: "#fff",
                                          textTransform: "capitalize",
                                          fontWeight: "600",
                                          fontSize: "16px",
                                          width: "160px",
                                        }}
                                        onClick={this.UpdatePledgeDataToBackend.bind(this)}
                                      >
                                        Save & Launch
                                      </Button>
                                    </a>
                                  )
                                );
                              })()}
                              <br></br>
                              <span
                                className="cursor-pointer anchortag pt-2"
                                style={{ fontSize: "12px" }}
                                onClick={this.onCopy}
                              >
                                Copy embed code for this meter to my clipboard.
                              </span>
                              {this.state.alertVisible && (
                                <span
                                  className="pledgeCopyToClipboard ms-auto text-start"
                                  style={{
                                    width: "190px",
                                    marginLeft: "350px",
                                  }}
                                >
                                  iFrame code copied to clipboard!
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div className="row mt-2">
                        <div className="col-md-12">
                          <div
                            className="row"
                            md={12}
                            style={{
                              alignItems: "flex-end",
                              margin: "1em 0em 0em 0em",
                            }}
                          >
                            <label className="form-label fw-bold p-0">
                               Logo
                              <span
                                className="p-0 ms-1"
                                style={{
                                  fontWeight: "normal",
                                  fontSize: "11px",
                                  color: "black",
                                }}
                              >
                                (max 400x100 pix - PNG, JPG, GIF)
                              </span>
                            </label>

                            <div className="row mt-2">
                              {!this.state.showFileView ? (
                                <>
                                  <div
                                    className="col-sm-3"
                                    style={{ width: "23%" }}
                                  ></div>
                                  <div className="col-sm-9 align-self-center p-0">
                                    <>
                                      <div
                                        className="col-sm-12 d-flex csvFile"
                                        style={{
                                          display: "inline-block",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <label
                                          htmlFor="file-upload-logo"
                                          className="custom-file-upload"
                                          style={{ width: "90px" }}
                                        >
                                          Add Logo
                                        </label>
                                        <input
                                          required
                                          id="file-upload-logo"
                                          type="file"
                                          ref={this.logoUploadRef}
                                          onChange={this.onLogoChange}
                                          onClick={(e) => {
                                            e.target.value = null;
                                            this.setState({
                                              imageError: "",
                                              selectedBanner: { name: "" },
                                            });
                                          }}
                                        />
                                        <p
                                          className="ms-2 mb-0"
                                          id="fileLabel"
                                          style={{
                                            display: "inline",
                                            width: "180px",
                                          }}
                                        >
                                          {this.state.selectedBanner?.name ===
                                          ""
                                            ? ""
                                            : Utils.truncateString(
                                                this.state.selectedBanner?.name,
                                                18
                                              )}
                                        </p>
                                      </div>
                                    </>
                                  </div>
                                  {this.state.currentFile &&
                                    !this.state.imageError && (
                                      <div className="mt-2 p-0">
                                        <img
                                          style={{
                                            maxWidth: "100%",
                                            height: "4em",
                                            objectFit: "contain",
                                            objectPosition: "left",
                                          }}
                                          alt=""
                                          src={
                                            this.state.currentFile
                                              ? this.state.currentFile
                                              : ""
                                          }
                                        />
                                      </div>
                                    )}
                                  <span
                                    style={{ color: "red", padding: "0px" }}
                                  >
                                    {this.state.imageError}
                                  </span>
                                </>
                              ) : (
                                <>
                                  <div
                                    className="col-sm-3"
                                    style={{ width: "23%" }}
                                  ></div>
                                  <div className="col-sm-9 ps-0 d-flex align-self-center">
                                    <img
                                      src={this.state.newUrl}
                                      alt=""
                                      style={{
                                        maxWidth: "100%",
                                        height: "4em",
                                        objectFit: "contain",
                                        objectPosition: "left",
                                      }}
                                    />
                                    <span className="fw-bold ms-1">
                                      <ClearIcon
                                        className="logoDelete"
                                        style={{
                                          cursor: "pointer",
                                          borderRadius: "50%",
                                          border: "solid 2px",
                                        }}
                                        onClick={this.deletePledgeBannerInBackend.bind(
                                          this
                                        )}
                                      />
                                    </span>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card " id="giveBeeCard">
                    <div
                      className="card-header d-flex align-items-start justify-content-between"
                      id="assetCardHeader"
                    >
                      <h6 className="mb-0" id="headerLabel">
                        Enter Off-line Donations
                      </h6>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12" id="givbeeText">
                          <ValidatorForm
                            className="text-start"
                            ref="form"
                            onSubmit={this.addDonationToBackend.bind(this)}
                          >
                            <div className="row mb-1">
                              <div className="row d-flex">
                                <div
                                  className="col-md-3 pe-2"
                                  id="assetFormLabel"
                                >
                                  <label
                                    className="form-label "
                                    htmlFor="collapsible-firstname"
                                  >
                                    Amount
                                  </label>
                                  <div className="col-md-12 d-flex">
                                    <span
                                      className="input-group-addon align-content-center inputFundraising"
                                      style={{ width: "40px" }}
                                    >
                                      $
                                    </span>
                                    <input
                                      title=""
                                      type="number"
                                      required
                                      autoFocus={
                                        this.state.addDonationAmountFocus
                                      }
                                      ref={this.donationAmountRef}
                                      autoComplete="off"
                                      id="multiStepsFirstName"
                                      name="multiStepsFirstName"
                                      className="form-control inputAmountPldge"
                                      value={this.state.addDonationAmount}
                                      onChange={this.handleAddDonationAmountChange.bind(
                                        this
                                      )}
                                      onFocus={(event) => {
                                        event.target.select();
                                      }}
                                    />
                                  </div>
                                </div>
                                <div
                                  className="col-md-3 pe-2"
                                  id="assetFormLabel"
                                >
                                  <label
                                    className="form-label "
                                    htmlFor="collapsible-lastname"
                                  >
                                    First Name
                                  </label>
                                  <input
                                    title=""
                                    required
                                    type="text"
                                    autoComplete="off"
                                    id="multiStepsFirstName"
                                    name="multiStepsFirstName"
                                    className="form-control inputDonation"
                                    value={this.state.addFirstName}
                                    onChange={this.handleAddFirstNameChange.bind(
                                      this
                                    )}
                                    validators={["required"]}
                                    errormessages={["This field is required"]}
                                  />
                                </div>
                                <div
                                  className="col-md-3 pe-2"
                                  id="assetFormLabel"
                                >
                                  <label
                                    className="form-label "
                                    htmlFor="collapsible-lastname"
                                  >
                                    Last Name
                                  </label>
                                  <input
                                    type="text"
                                    autoComplete="off"
                                    id="multiStepsFirstName"
                                    name="multiStepsFirstName"
                                    className="form-control inputDonation"
                                    value={this.state.addLastName}
                                    onChange={this.handleAddLastNameChange.bind(
                                      this
                                    )}
                                    validators={["required"]}
                                    errormessages={["This field is required"]}
                                  />
                                </div>
                                <div
                                  className="col-md-3 align-content-end"
                                  id="assetFormLabel"
                                >
                                  <Button
                                    className="fw-bold"
                                    id="ptsHollowButton"
                                    type="submit"
                                    style={{
                                      width: "90px",
                                      cursor: "pointer",
                                      textTransform: "capitalize",
                                      padding: "2px 10px",
                                      marginBottom: "2.5px",
                                    }}
                                    startIcon={
                                      <AddIcon style={{ fontWeight: "600" }} />
                                    }
                                  >
                                    Add
                                  </Button>
                                </div>
                              </div>
                              <div className="row d-flex mt-2">
                                <div className="col-md-3"></div>
                                <div className="col-md-6 d-flex align-items-start">
                                  <span className="me-2 align-self-center">
                                    <input
                                      type="checkbox"
                                      style={{
                                        cursor: "pointer",
                                        alignSelf: "flex-start",
                                      }}
                                      value={this.state.isAnonymous}
                                      onChange={(e) =>
                                        this.handleAddShowAnonymous(e)
                                      }
                                      checked={this.state.isAnonymous}
                                    />
                                  </span>
                                  <p
                                    className="form-label "
                                    htmlFor="collapsible-lastname"
                                    style={{ cursor: "pointer" }}
                                    onClick={(e) =>
                                      this.handleAddShowAnonymous(e)
                                    }
                                  >
                                    Show as "Anonymous"
                                  </p>
                                </div>
                              </div>
                            </div>
                          </ValidatorForm>
                        </div>
                      </div>
                      <hr></hr>
                      <div className="row">
                        <div className="col-md-12" id="givbeeText">
                          <div className="row d-flex mt-2">
                            <div className="col-sm-6">
                              <label
                                className="form-label fw-bold"
                                htmlFor="collapsible-firstname"
                              >
                                Import Donations
                              </label>
                            </div>
                            <div className="col-sm-6 text-end">
                              <a
                                className="anchortag"
                                href={DonationImportFile}
                                style={{
                                  color: "#1957b4",
                                  cursor: "pointer",
                                  fontSize: "13.5px",
                                }}
                                id="dwnlink"
                                download="GivBeeDonations.csv"
                              >
                                <u>Download CSV template</u>
                              </a>
                            </div>
                          </div>
                          <div
                            className="row align-items-center"
                            style={{ marginTop: "15px", height: "75px" }}
                          >
                            {this.state.selectedDonationFile?.name === "" ?
                              <div
                                className="col-sm-6 pledgecsvFile"
                                style={{
                                  display: "inline-block",
                                  cursor: "pointer",
                                }}
                              >
                                <div className="file-upload-wrapper">
                                  <label
                                    htmlFor="import-csvfile"
                                    className={`customImageVideo-file-upload ${this.state.isDragging ? "dragging" : ""
                                      }`}
                                    onDrop={this.handleDonationFileDrop}
                                    onDragOver={this.handleDonationFileDragOver}
                                    onDragLeave={this.handleDonationFileDragLeave}
                                  >
                                    <CloudUploadIcon className="upload-icon" />
                                    <span className="upload-text">
                                      Drop or{" "}
                                      <span className="browse-link">browse CSV files here</span>
                                    </span>

                                    <input
                                      required
                                      id="import-csvfile"
                                      type="file"
                                      accept=".csv"
                                      ref={this.fileUploadRef}
                                      onChange={this.handleDonationFileChange}
                                    />
                                  </label>

                                  {/* <small className="upload-note">
                                    {this.state.selectedDonationFile?.name === ""
                                      ? "Choose CSV file"
                                      : this.state.selectedDonationFile?.name}
                                  </small> */}
                                </div>
                              </div>
                              :
                              <div
                                className="col-sm-12 pledgecsvFile"
                                style={{
                                  display: "inline-block",
                                  cursor: "pointer",
                                }}
                              >
                                <div className="align-content-center" style={{ height: "76.61px" }}>
                                  <p
                                    className="mb-0 anchortag"
                                    id="fileLabel"
                                    style={{ display: "inline" }}
                                  >
                                    {this.state.selectedDonationFile?.name === ""
                                      ? ""
                                      : this.state.selectedDonationFile?.name}
                                  </p>
                                  <span className="fw-bold ms-2">
                                    <ClearIcon
                                      className="logoDelete"
                                      style={{
                                        cursor: "pointer",
                                        borderRadius: "50%",
                                        border: "solid 2px",
                                        color: "#697a8d",
                                      }}
                                      onClick={this.cancelDonationExcelFile.bind(
                                        this
                                      )}
                                    />
                                  </span>
                                  <Button
                                    className="ms-3"
                                    id="ptsHollowButton"
                                    variant="contained"
                                    style={{
                                      width: "100px",
                                    }}
                                    onClick={this.excelImportDonation.bind(this)}
                                  >
                                    Import
                                  </Button>
                                </div>
                              </div>
                            }

                          </div>
                        </div>
                      </div>
                      <hr></hr>
                      <div className="row justify-content-end">
                        <div className="col-md-8 m-0" id="givbeeText">
                          <div className="row mt-2 d-flex justify-content-end">
                            <label
                              className="col-md-8 form-label text-end"
                              htmlFor="collapsible-firstname"
                            >
                              Off-line Donations Entered:
                            </label>
                            <div className="col-md-4 d-flex">
                              <span className="inputFundraising">$</span>
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                id="multiStepsFirstName"
                                name="multiStepsFirstName"
                                className="form-control inputPldge"
                                value={this.state.offlineDonation?.toLocaleString()}
                                //   onChange={this.handleDonationAmountEnteredChange.bind(this)}
                                onFocus={(event) => {
                                  event.target.select();
                                }}
                              />
                            </div>
                          </div>
                          <div className="row mt-2 d-flex justify-content-end">
                            <label
                              className="col-md-8 form-label text-end"
                              htmlFor="collapsible-firstname"
                            >
                              Donation Processed Via Text:
                            </label>
                            <div className="col-md-4 d-flex">
                              <span className="inputFundraising">$</span>
                              <input
                                type="text"
                                disabled
                                autoComplete="off"
                                id="multiStepsFirstName"
                                name="multiStepsFirstName"
                                className="form-control inputPldge"
                                value={this.state.textDonation?.toLocaleString()}
                                //   onChange={this.handleDonationAmountChange.bind(this)}
                                onFocus={(event) => {
                                  event.target.select();
                                }}
                              />
                            </div>
                          </div>
                          <div className="row mt-2 d-flex justify-content-end">
                            <label
                              className="col-md-6 form-label fw-bold text-end"
                              htmlFor="collapsible-firstname"
                            >
                              Current Total:
                            </label>
                            <div className="col-md-4 form-label fw-bold text-end">
                              {`$${Utils.formatWithCommas(
                                this.state.totalDonation
                              )}`}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {this.state.donationList.length > 0 && (
            <>
              {this.state.getReportPermission && (
                <div
                  className="mt-4"
                  style={{ width: "100%", textAlign: "end" }}
                >
                  <Button
                    id="ptsHollowButton"
                    type="submit"
                    startIcon={
                      <i
                        className="fa fa-download"
                        style={{ fontSize: "16px" }}
                      ></i>
                    }
                    onClick={(e) => this.excelDownloadDonationList()}
                  >
                    Download Meter Data
                  </Button>
                </div>
              )}
              <div
                className="mt-2 donationMaterialTable"
                style={{ width: "100%" }}
              >
                <MaterialTable
                  title="Scrolling Meter List"
                  icons={UiUtils.getMaterialTableIcons()}
                  localization={{
                    body: {
                      emptyDataSourceMessage: "",
                    },
                  }}
                  columns={[
                    {
                      title: "#",
                      render: (rowData) => rowData.tableData.id + 1,
                      width: "5%",
                      align: "left",
                      cellStyle: {
                        width: "6%",
                      },
                    },
                    {
                      title: "Amount",
                      field: "amount",
                      render: (rowData) =>
                        `$${Utils.formatWithCommas(rowData.amount)}`,
                      cellStyle: {
                        width: "22%",
                      },
                    },
                    {
                      title: "First Name",
                      field: "firstName",
                      cellStyle: {
                        width: "22%",
                      },
                    },
                    {
                      title: "Last Name",
                      field: "lastName",
                      cellStyle: {
                        width: "22%",
                      },
                    },
                    {
                      title: "Anonymous",
                      render: (rowData) =>
                        rowData.isShowAnonymous ? "Yes" : "No",
                      cellStyle: {
                        width: "15%",
                      },
                    },

                    // {
                    //   title: "Actions",
                    //   sorting: false,
                    //   disableClick: true,
                    //   render: (rowData) => this.showActionButton(rowData),
                    //   cellStyle: {
                    //     width: "10%",
                    //   },
                    //   headerStyle: {
                    //     textAlign: "center",
                    //   },
                    // },
                  ]}
                  data={this.state.donationList}
                  options={{
                    emptyRowsWhenPaging: false,
                    sorting: true,
                    search: true,
                    actionsColumnIndex: -1,
                    initialPage: this.state.initialPage,
                    pageSize: this.state.pageSize,
                    pageSizeOptions: Utils.materialTablePageSize(),
                    paging: this.state.isPaging,
                    headerStyle: {
                      backgroundColor: "#37517e",
                      fontWeight: "bold",
                      color: "#ffff",
                      align: "left",
                    },
                  }}
                  onChangePage={(page, pageSize) => {
                    this.handleMaterialTablePageChange(page, pageSize);
                  }}
                  actions={[
                    (rowData) =>
                      rowData.ismanual
                        ? {
                          icon: () => (
                            <span style={{ padding: "2px 4px" }}>
                              <EditButton />
                            </span>
                          ),
                          // tooltip: "Edit",
                          hidden: !rowData.ismanual,
                          onClick: (event, rowData) =>
                            this.editDonationDetails(rowData),
                        }
                        : {
                          icon: () => (
                            <span
                              style={{ width: "39px", padding: "3px" }}
                            ></span>
                          ),
                        },
                    (rowData) => ({
                      icon: () => (
                        <span style={{ padding: "2px 4px" }}>
                          <DeleteIcon
                            style={{
                              borderRadius: "25%",
                              color: "#6A7B8E",
                              fontSize: "x-large",
                              width: "30px",
                              minHeight: "30px",
                              padding: "3px",
                            }}
                          />
                        </span>
                      ),
                      tooltip: "Delete",
                      onClick: this.handleDonationOpen.bind(this, rowData),
                    }),
                  ]}
                />
              </div>
            </>
          )}
          <Dialog
            open={this.state.open}
            onClose={this.handleClose.bind(this)}
            maxWidth="xl"
            className="QRCodeDialogue"
          >
            <DialogTitle id="scroll-dialog-title">
              <span style={{ color: "#fff" }}>Edit</span>
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={this.handleClose.bind(this)}
              style={{
                position: "absolute",
                right: 8,
                top: 4,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
            </IconButton>
            <ValidatorForm
              className="text-start"
              ref="form"
              onSubmit={this.updateDonationToBackend.bind(this)}
            >
              <DialogContent>
                <div
                  style={{
                    width: "100%",
                    color: "#000",
                    fontSize: "small",
                    padding: "0.5em",
                  }}
                >
                  <div className="row d-flex">
                    <div className="col-md-4" id="assetFormLabel">
                      <label
                        className="form-label "
                        htmlFor="collapsible-firstname"
                      >
                        Amount
                      </label>
                      <div className="col-md-12 d-flex">
                        <span
                          className="input-group-addon align-content-center inputFundraising"
                          style={{ width: "40px" }}
                        >
                          $
                        </span>
                        <input
                          title=""
                          type="number"
                          disabled
                          required
                          ref={this.donationAmountRef}
                          autoComplete="off"
                          id="multiStepsFirstName"
                          name="multiStepsFirstName"
                          className="form-control inputPldge"
                          value={this.state.donationAmount}
                          onChange={this.handleDonationAmountChange.bind(this)}
                          onFocus={(event) => {
                            event.target.select();
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4" id="assetFormLabel">
                      <label
                        className="form-label "
                        htmlFor="collapsible-lastname"
                      >
                        First Name
                      </label>
                      <input
                        title=""
                        required
                        type="text"
                        autoComplete="off"
                        id="multiStepsFirstName"
                        name="multiStepsFirstName"
                        className="form-control inputDonation"
                        value={this.state.firstName}
                        onChange={this.handleFirstNameChange.bind(this)}
                        validators={["required"]}
                        errormessages={["This field is required"]}
                      />
                    </div>
                    <div className="col-md-4" id="assetFormLabel">
                      <label
                        className="form-label "
                        htmlFor="collapsible-lastname"
                      >
                        Last Name
                      </label>
                      <input
                        type="text"
                        autoComplete="off"
                        id="multiStepsFirstName"
                        name="multiStepsFirstName"
                        className="form-control inputDonation"
                        value={this.state.lastName}
                        onChange={this.handleLastNameChange.bind(this)}
                        validators={["required"]}
                        errormessages={["This field is required"]}
                      />
                    </div>
                  </div>
                  <div className="row d-flex mt-2">
                    <div className="col-md-4"></div>
                    <div className="col-md-6 d-flex align-items-start">
                      <span className="me-2 align-self-center">
                        <input
                          type="checkbox"
                          style={{
                            cursor: "pointer",
                            alignSelf: "flex-start",
                          }}
                          value={this.state.isShowAnonymous}
                          onChange={(e) => this.handleShowAnonymous(e)}
                          checked={this.state.isShowAnonymous}
                        />
                      </span>
                      <p
                        className="form-label "
                        htmlFor="collapsible-lastname"
                        style={{ cursor: "pointer" }}
                        onClick={(e) => this.handleShowAnonymous(e)}
                      >
                        Show as "Anonymous"
                      </p>
                    </div>
                  </div>
                </div>
              </DialogContent>
              <DialogActions className="text-center justify-content-center pb-3">
                <SaveButton type="Submit" />
              </DialogActions>
            </ValidatorForm>
          </Dialog>
          <Dialog
            open={this.state.tickerOverlayOpen}
            onClose={this.handleTickerOverlayClose.bind(this)}
            maxWidth="xl"
            className="TickerOverlayDialogue"
          >
            <DialogTitle id="scroll-dialog-title">
              <span style={{ color: "#fff" }}>Ticker Overlay</span>
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={this.handleTickerOverlayClose.bind(this)}
              style={{
                position: "absolute",
                right: 8,
                top: 4,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
            </IconButton>
            <DialogContent>
              <div className="row d-flex">
                <div className="col-md-12">
                  <div
                    style={{
                      textAlign: "center",
                      background: "#39b54a",
                      height: "220px",
                      // width: "258px",
                      position: "relative",
                      overflow: "hidden", // Prevents content overflow
                      display: "flex",
                      alignItems: "flex-end",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: "42%",
                        left: "50%",
                        width: "100%",
                        transform: "translate(-50%, -50%)",
                        // fontWeight: "bold",
                        color: "#ffff",
                        fontSize: "18px",
                        textAlign: "center",
                        // padding: "0 31px",
                        zIndex: 1,
                      }}
                    >
                      Your slideshow or video will play here.
                    </div>
                    <div
                      className="col-sm-12 d-flex align-items-center"
                      style={{
                        width: "100%",
                        backgroundColor: "black",
                        padding: "2px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          gap: "20px",
                          fontSize: "14px",
                          fontWeight: "700",
                          color: "#fff",
                          animation: "scrollLeft 20s linear infinite",
                        }}
                      >
                        {this.state.donationList
                          .concat(this.state.donationList) // Duplicate list for smooth scrolling
                          .map((item, index) => (
                            <span key={index}>
                              {item.isShowAnonymous
                                ? "Anonymous"
                                : `${item.firstName} ${item.lastName}`}{" "}
                              ${item.amount} &nbsp;&nbsp;
                            </span>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 mt-3">
                  <p style={{ fontSize: "12px" }}>
                    With this Scrolling Ticker you can display your donation
                    data over a slideshow, streaming video or pre-recorded
                    video.
                  </p>
                  <p style={{ fontSize: "12px" }}>
                    If you're working with a video expert just launch the
                    ticker, copy its web address and email it to your expert
                    who'll be able to combine it with your slideshow or video.
                  </p>
                  <p style={{ fontSize: "12px" }}>
                    Don't have a video expert? Download free video software such
                    as OBS Studio and search YouTube for tutorials such as:
                    <br></br>
                    <a
                      className="anchortag"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`https://www.google.com/search?q=${encodeURIComponent(
                        "How to live stream with a green screen using OBS Studio"
                      )}`}
                    >
                      {" "}
                      How to live stream with a green screen using OBS Studio
                    </a>{" "}
                    <br></br>
                    <a
                      className="anchortag"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`https://www.google.com/search?q=${encodeURIComponent(
                        "How to use OBS green screen"
                      )}`}
                    >
                      {" "}
                      How to use OBS green screen
                    </a>
                  </p>
                </div>
              </div>
            </DialogContent>
          </Dialog>

          <Dialog
            open={this.state.donationOpen}
            onClose={this.handleDonationClose.bind(this)}
            style={{ padding: "1em" }}
          >
            <DialogContent>
              <span style={{ textAlign: "center" }}>
                <p className="m-0" style={{ fontSize: "16px" }}>
                  This donation will be deleted.
                </p>
              </span>
            </DialogContent>
            <DialogActions
              style={{
                padding: "1em",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <Button
                variant="contained"
                type="button"
                size="large"
                style={{
                  background: "#37517e",
                  color: "#fff",
                  marginRight: "1rem",
                  padding: "2px 10px",
                  textTransform: "capitalize",
                }}
                startIcon={<SaveIcon />}
                onClick={this.deleteDonationToBackend.bind(this)}
              >
                Confirm
              </Button>
              <Button
                variant="contained"
                size="large"
                type="button"
                style={{
                  background: "#717373",
                  color: "#fff",
                  marginRight: "1rem",
                  padding: "2px 10px",
                  textTransform: "capitalize",
                }}
                startIcon={<CloseIcon />}
                onClick={this.handleDonationClose.bind(this)}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
        </>
      );
    }
  }
}
export default withRouter(Pledge);
